<template>
  <div style="background-color: #ebebeb">
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:15%" light timeout="-1" v-model="alertShow"
                width="fit-content" top centered>
      <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <div class="margin-lotto-desktop my-5 hidden-sm-and-down">
      <v-row no-gutters>
        <v-col cols="12">
        </v-col>
      </v-row>
      <!--desktop view-->
      <div class="lottery-wrapper">
        <h2 class="lottery-title">{{ $t('lotto.pageTitle') }}</h2>

        <div class="lottery-card">
          <div class="left-panel">
            <p class="subtitle">{{ $t('lotto.dailyDraw') }}</p>

            <img src="/static/image/lotto/lottery-ticket.png" class="ticket-graphic" />

            <p class="hint-text">{{ $t('lotto.depositHint') }}</p>

            <div class="prize-boxes">
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.1stUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(firstPrizeUpTo, currentCurrency) }}</p>
              </div>
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.2ndUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(secondPrizeUpTo, currentCurrency) }}</p>
              </div>
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.3rdUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(thirdPrizeUpTo, currentCurrency) }}</p>
              </div>
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.4thUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(specialPrizeUpTo, currentCurrency) }}</p>
              </div>
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.5thUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(consolationPrizeUpTo, currentCurrency) }}</p>
              </div>
            </div>
          </div>

          <div class="vertical-divider"></div>

          <div class="right-panel">
            <span class="ticket-id">#{{ activeId }}</span>

            <p class="draw-closes-label">{{ $t('lotto.drawClosesIn') }}</p>

            <div class="countdown-boxes">
              <div class="countdown-box">{{ countdownHour }}</div>
              <span class="countdown-colon">:</span>
              <div class="countdown-box">{{ countdownMinute }}</div>
              <span class="countdown-colon">:</span>
              <div class="countdown-box">{{ countdownSecond }}</div>
            </div>

            <div class="active-tickets">
              <p class="active-tickets-label">{{ $t('lotto.yourActiveTickets') }}</p>
              <p class="active-tickets-value">{{ walletBalances.active_tickets || 0 }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- marquee -->
      <div class="lotto-marquee-row">
        <div class="lotto-marquee-wrapper">
          <div class="lotto-marquee">
            <div class="lotto-marquee-content">
              <template v-for="activity in lottoTicketActivity">
              <span  class="pr-6 mr-6">
                <label class="d-inline-block home-announcment-content white--text">{{ activity.member_name }} got</label>
                <label class="d-inline-block home-announcment-content mx-1" style="color: #FFCE01 !important;">{{ activity.ticket_count }}</label>
                <label class="d-inline-block home-announcment-content white--text">ticket</label>
              </span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- how to earn tickets -->
      <div class="tickets-section hidden-sm-and-down">
        <div>
          <p class="text-tickets">{{ $t(`lotto.howToEarnTickets`) }}</p>
        </div>
        <div class="tickets-list">
          <div class="tickets-box">
            <div class="tickets-header-row">
              <div class="ticket-text">
                <p>{{ $t(`lotto.depositToGetTickets`) }}</p>
                <p class="subtitle">{{ $t(`lotto.depositProgressHint`, [ticketSetting ? this.getCurrencyValue(ticketSetting.threshold_value, depositProgress.threshold_value): '0.00', ticketSetting ? this.getTicket(ticketSetting.tickets_to_grant, depositProgress.tickets_to_grant): 0]) }}</p>
              </div>
              <div class="bonus-badge">+{{ ticketSetting ? this.getTicket(ticketSetting.tickets_to_grant, depositProgress.tickets_to_grant): 0 }}</div>
            </div>
            <div class="progress-track">
              <div class="progress-fill" :style="{ width: `${getProgressValue(0, depositProgress.progress_pct)}%` }"></div>
            </div>

            <p class="progress-label">{{ ticketSetting ? this.getCurrencyValue(0, depositProgress.progress_value % depositProgress.threshold_value): '0.00' }} / {{ ticketSetting ? this.getCurrencyValue(ticketSetting.threshold_value, depositProgress.threshold_value): '0.00' }}</p>
          </div>
        </div>
      </div>

      <!-- winning -->
      <div class="winning-section hidden-sm-and-down" v-if="isLoggedIn">
        <div class="winning-box">
          <div>
            <p>{{ $t(`lotto.myWinnings`) }}:</p>
            <p class="winnings-amount">{{ currencyFormatter(walletBalances.unclaimed || 0, currentCurrency) }}</p>
          </div>
          <button class="btn-claim" @click="claimBalances()" :disabled="!isLoggedIn">{{ $t(`label.claim`) }}</button>
        </div>
        <div class="winning-box">
          <div>
            <p>{{ $t(`lotto.lifetimeWinnings`) }}</p>
            <p class="winnings-amount">{{ currencyFormatter(walletBalances.total || 0, currentCurrency) }}</p>
          </div>
        </div>
        <div class="winning-box">
          <div>
            <p>{{ $t(`lotto.activeTickets`) }}:</p>
            <div class="active-tickets">
              <p class="active">{{ walletBalances.active_tickets || 0 }}</p>
              <!--            <p>/{{ walletBalances.daily_stock || 0 }}</p>-->
            </div>
          </div>
        </div>
        <div class="winning-box">
          <div>
            <p>{{ $t(`lotto.lastDrawWinningTickets`) }}:</p>
            <p class="winnings-amount">{{ walletBalances.last_draw_winning_tickets || 0 }}</p>
          </div>
        </div>
      </div>

      <!-- my tickets -->
      <div class="my-tickets-section hidden-sm-and-down" v-if="isLoggedIn">
        <p class="title">{{ $t('lotto.myTickets') }}</p>
        <div class="my-tickets-tabs">
          <div class="button-tabs">
            <button :class="{ active: subTab === 'active' }" @click="clickTicketsSubTab('active')">{{ $t(`lotto.active`) }}</button>
            <button :class="{ active: subTab === 'past' }" @click="clickTicketsSubTab('past')">{{ $t(`lotto.past`) }}</button>
          </div>
          <div v-if="subTab === 'past'" class="nav-bar ticket-past-nav-bar">
            <v-icon @click="prevTicketDate">mdi-chevron-left</v-icon>
            <div class="center-content">
              <v-menu offset-y max-height="300">
                <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="code-select">
                            <span>{{ currentTicketDate }} | {{ currentTicketCode }}</span>
                            <v-icon small>mdi-chevron-down</v-icon>
                          </span>
                </template>
                <v-list>
                  <v-list-item
                      v-for="(date, index) in pastTicketDateList"
                      :key="date.id"
                      @click="selectCode(index)"
                  >
                    <v-list-item-title>{{ date.drawDate }}|{{ date.id }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-icon @click="nextTicketDate">mdi-chevron-right</v-icon>
          </div>
        </div>

        <div class="my-tickets-info">
          <div v-if="subTab === 'active'" class="ticket-active" :class="activePagination.total > 0 ? '' : 'ticket-no-result'">
            <v-col v-if="activePagination.total === 0" class="no-result">
              <p>{{ $t(`lotto.depositEarnTicket`) }}</p>
              <p>{{ $t(`lotto.startDepositForTickets`) }}</p>
            </v-col>
            <v-col v-else cols="6" v-for="(a, index) in activeTicketList" :key="index" class="ticket-list">
              <div class="ticket-card">
                <div class="ticket-main">
                  <div class="ticket-badges">
                    <span class="badge badge--draw">{{ $t('lotto.inDraw') }}</span>
                    <span class="badge badge--type">{{ $t(`lotto.${a.numbers[0].match_type}`) }}</span>
                  </div>

                  <div class="ticket-digits">
                    <span
                        v-for="(digit, i) in String(a.numbers[0].number).split('')"
                        :key="i"
                        class="digit-box"
                    >{{ digit }}</span>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" style="float:right"
                                dark
                                v-bind="attrs"
                                v-on="on">
                          info
                        </v-icon>
                      </template>
                      <div>
                        <div v-for="(amount, prizeKey) in a.numbers[0].potential_winning" :key="prizeKey" style="font-size: 12px">
                          {{ $t(`lotto.${prizeKey}`) }}: {{ currencyFormatter(amount, currentCurrency) }}
                        </div>
                      </div>
                    </v-tooltip>
                  </div>

                  <p class="ticket-meta">
                    {{ a.draw_date }} | #{{ a.draw_id }}
                  </p>
                </div>

                <div class="ticket-divider"></div>

                <div class="ticket-chances">
                  <p class="chances-label">{{ $t('lotto.chances') }}</p>
                  <p class="chances-value">{{ a.numbers[0].permutations }}x</p>
                  <p class="chances-sub">{{ $t('lotto.permutations') }}</p>
                </div>
              </div>
            </v-col>
            <v-row no-gutters class="py-4" v-if="activePagination.last_page > 1">
              <v-col cols="12" class="text-center">
                <v-pagination
                    class="trxn_history_pagination"
                    v-model="activePagination.current_page"
                    :length="activePagination.last_page"
                    @input="changeActivePage"
                    :next-icon="'arrow_forward_ios'"
                    :prev-icon="'arrow_back_ios'"
                    :total-visible="10"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
          <div v-else-if="subTab === 'past'" class="ticket-past" :class="pastTicketList.length > 0 ? '' : 'ticket-past-no-result'">
            <v-col v-if="pastTicketList.length === 0" class="no-result">
              <p>{{ $t(`lotto.depositEarnTicket`) }}</p>
              <p>{{ $t(`lotto.startDepositForTickets`) }}</p>
            </v-col>

            <v-col cols="12" v-if="pastTicketList.length > 0" class="ticket-list">
              <div>
                <div class="text-your-ticket">
                  <p>{{ $t(`lotto.yourTicket`) }}</p>
                </div>
                <div class="ticket-permutations">
                  <p>{{ $t(`lotto.prize`) }}</p>
                </div>
              </div>
              <div class="ticket-next-draw">
                <p>
                  {{ $t(`lotto.amount`) }}
                </p>
              </div>
            </v-col>
            <v-col cols="12" v-for="(a, index) in pastTicketList" :key="index" class="ticket-list">
              <div>
                <div :class="a.numbers[0].match_type === 'miss' ? 'ticket-number': 'ticket-number-blue'">
                  <p>{{ a.numbers[0].number }}</p>
                </div>
                <div v-if="a.numbers[0].match_type === 'miss'" class="ticket-permutations">
                  <p>{{ $t(`lotto.${a.numbers[0].match_type}`) }}</p>
                </div>
                <div v-else class="ticket-permutations">
                  <p class="text-blue">{{ a.numbers[0].matched_number }} ({{ $t(`lotto.${a.numbers[0].prize_code}`) }})</p>
                  <p>{{ a.numbers[0].permutations }} {{ $t(`lotto.permutations`) }}</p>
                </div>
              </div>
              <div class="ticket-next-draw">
                <p :class="a.numbers[0].win_amount > 0 ? 'text-green' : ''">
                  {{ a.numbers[0].win_amount > 0 ? '+ ' : '' }}{{ currencyFormatter(a.numbers[0].win_amount, currentCurrency)}}
                </p>
              </div>
            </v-col>



            <v-row no-gutters class="py-4" v-if="pagination.last_page > 1">
              <v-col cols="12" class="text-center">
                <v-pagination
                    class="trxn_history_pagination"
                    v-model="pagination.current_page"
                    :length="pagination.last_page"
                    @input="changePage"
                    :next-icon="'arrow_forward_ios'"
                    :prev-icon="'arrow_back_ios'"
                    :total-visible="10"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

      <!-- last draw result -->
      <div class="last-draw-results">
        <div class="page-header">
          <p class="page-title">{{ $t('lotto.lastDrawResults') }}</p>
          <p class="page-subtitle">
            {{ getLastDrawLabel(this.lastDrawDate, this.lastHistoryId) }}
          </p>
        </div>

        <div class="match-banner">
          <img src="/static/image/lotto/icon-matches.png" class="match-icon" />
          <div class="match-text">
            <p class="match-title">
              {{ $t('lotto.matchedNumbers', [ lastHistoryMatches ]) }}
            </p>
            <!--            <p class="match-breakdown">{{ lastHistoryMatches }}</p>-->
          </div>
        </div>

        <div class="top-prizes-card">
          <div class="top-prize-row">
            <p class="top-prize-label first-prize-label">{{ $t(`lotto.1ST`) }}
              <span v-if="isTopPrizeMatched('1st_prize')" class="top-matched-star">★</span>
            </p>
            <div class="digit-boxes">
              <span
                  v-for="(digit, i) in String(this.lastFirstPrize).split('')"
                  :key="'1st-' + i"
                  class="digit-box"
                  :class="isTopPrizeMatched('1st_prize') ? 'matched-number': ''"
              >{{ digit }}</span>
            </div>
          </div>

          <div class="top-prize-row">
            <p class="top-prize-label second-prize-label">{{ $t(`lotto.2ND`) }}
              <span v-if="isTopPrizeMatched('2nd_prize')" class="top-matched-star">★</span>
            </p>
            <div class="digit-boxes">
          <span
              v-for="(digit, i) in String(this.lastSecondPrize).split('')"
              :key="'2nd-' + i"
              class="digit-box"
              :class="isTopPrizeMatched('2nd_prize') ? 'matched-number': ''"
          >{{ digit }}</span>
            </div>
          </div>

          <div class="top-prize-row">
            <p class="top-prize-label third-prize-label">{{ $t(`lotto.3RD`) }}
              <span v-if="isTopPrizeMatched('3rd_prize')" class="top-matched-star">★</span>
            </p>
            <div class="digit-boxes">
          <span
              v-for="(digit, i) in String(this.lastThirdPrize).split('')"
              :key="'3rd-' + i"
              class="digit-box"
              :class="isTopPrizeMatched('3rd_prize') ? 'matched-number': ''"
          >{{ digit }}</span>
            </div>
          </div>
        </div>

        <div class="prize-section">
          <div class="section-header">
            <p class="section-title">{{ $t('lotto.4TH') }}</p>
            <span class="count-badge">x{{ lastSpecialPrizes.length }}</span>
          </div>
          <div class="numbers-grid">
            <div
                v-for="(n, i) in lastSpecialPrizes"
                :key="'special-' + i"
                class="number-card"
                :class="lastMatchedSpecialIndexes.includes(i) ? 'matched-number': ''"
            >
              <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
              <span class="number-value">{{ n }}</span>
              <span v-if="lastMatchedSpecialIndexes.includes(i)" class="matched-star">★</span>
            </div>
          </div>
        </div>

        <div class="prize-section">
          <div class="section-header">
            <p class="section-title">{{ $t('lotto.5TH') }}</p>
            <span class="count-badge">x{{ lastConsolationPrizes.length }}</span>
          </div>
          <div class="numbers-grid">
            <div
                v-for="(n, i) in lastConsolationPrizes"
                :key="'consolation-' + i"
                class="number-card"
                :class="lastMatchedConsolationIndexes.includes(i) ? 'matched-number': ''"
            >
              <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
              <span class="number-value">{{ n }}</span>
              <span v-if="lastMatchedConsolationIndexes.includes(i)" class="matched-star">★</span>
            </div>
          </div>
        </div>
      </div>

      <!-- past result -->
      <div class="past-results-card">
        <div class="past-result-row">
          <p class="past-result-title">{{ $t('lotto.pastResults') }}</p>
          <div class="nav-bar ticket-past-nav-bar">
            <v-icon @click="prevResultDate">mdi-chevron-left</v-icon>
            <div class="center-content">
              <v-menu offset-y max-height="300">
                <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="code-select">
                            <span>{{ currentResultDate }} | {{ currentResultCode }}</span>
                            <v-icon small>mdi-chevron-down</v-icon>
                          </span>
                </template>
                <v-list>
                  <v-list-item
                      v-for="(date, index) in pastResultDateList"
                      :key="date.id"
                      @click="selectResultCode(index)"
                  >
                    <v-list-item-title>{{ date.drawDate }}|{{ date.id }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-icon @click="nextResultDate">mdi-chevron-right</v-icon>
          </div>
        </div>

        <div class="draw-row-wrapper">
          <div class="draw-summary-row">
            <div class="draw-date-info">
              <p class="draw-date">{{ this.currentResultDate }}</p>
              <p class="draw-id">#{{ this.currentResultCode }}</p>
            </div>

            <div class="draw-top-prizes">
              <div class="mini-prize">
                <p class="mini-prize-label first-prize-label">1st</p>
                <span class="mini-digit-box"
                      :class="isPastTopPrizeMatched('1st_prize') ? 'matched-number': ''">
                  {{ this.pastFirstPrize }}
                </span>
                <span v-if="isPastTopPrizeMatched('1st_prize')" class="top-matched-star">★</span>
              </div>
              <div class="mini-prize">
                <p class="mini-prize-label second-prize-label">2nd</p>
                <span class="mini-digit-box"
                      :class="isPastTopPrizeMatched('2nd_prize') ? 'matched-number': ''">
                  {{ this.pastSecondPrize }}
                </span>
                <span v-if="isPastTopPrizeMatched('2nd_prize')" class="top-matched-star">★</span>
              </div>
              <div class="mini-prize">
                <p class="mini-prize-label third-prize-label">3rd</p>
                <span class="mini-digit-box"
                      :class="isPastTopPrizeMatched('3rd_prize') ? 'matched-number': ''">
                  {{ this.pastThirdPrize }}
                </span>
                <span v-if="isPastTopPrizeMatched('3rd_prize')" class="top-matched-star">★</span>
              </div>
            </div>

            <div class="draw-match-info">
              <span class="match-badge">
                {{ $t('lotto.match', [ pastMatches ]) }}
              </span>
            </div>
          </div>

          <div class="draw-expanded">
            <div class="prize-section">
              <div class="prize-border">
                <div class="section-header">
                  <p class="section-title">{{ $t('lotto.4TH') }}</p>
                  <span class="count-badge">x{{ pastSpecialPrizes.length }}</span>
                </div>
                <div class="numbers-grid">
                  <div
                      v-for="(n, i) in pastConsolationPrizes"
                      :key="'special-' + i"
                      class="number-card"
                      :class="pastMatchedSpecialIndexes.includes(i) ? 'matched-number': ''"
                  >
                    <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
                    <span class="number-value">{{ n }}</span>
                    <span v-if="pastMatchedSpecialIndexes.includes(i)" class="matched-star">★</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="prize-section">
              <div class="prize-border">
                <div class="section-header">
                  <p class="section-title">{{ $t('lotto.5TH') }}</p>
                  <span class="count-badge">x{{ pastConsolationPrizes.length }}</span>
                </div>
                <div class="numbers-grid">
                  <div
                      v-for="(n, i) in pastConsolationPrizes"
                      :key="'consolation-' + i"
                      class="number-card"
                      :class="pastMatchedConsolationIndexes.includes(i) ? 'matched-number': ''"
                  >
                    <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
                    <span class="number-value">{{ n }}</span>
                    <span v-if="pastMatchedConsolationIndexes.includes(i)" class="matched-star">★</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- faq -->
      <div class="faq-section hidden-sm-and-down">
        <div>
          <p class="text-rules">{{ $t(`lotto.faq`) }}</p>
        </div>
        <div class="accordion">
          <div
              v-for="(item, index) in faqItems"
              :key="index"
              class="accordion-item"
          >
            <div class="accordion-header" @click="toggle(index)">
              <span>{{ $t(item.title) }}</span>
              <span class="arrow" :class="{ open: openIndex === index }">▼</span>
            </div>
            <div v-show="openIndex === index" class="accordion-body">
              <p v-html="$t(item.content)" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile view -->
    <div class="margin-lotto-mobile hidden-md-and-up">
      <div class="lottery-wrapper">
        <h2 class="lottery-title">{{ $t('lotto.pageTitle') }}</h2>

        <div class="lottery-card">
          <div class="top-panel">
            <div class="d-flex justify-space-between">
              <p class="subtitle">{{ $t('lotto.dailyDraw') }}</p>
              <span class="ticket-id">#{{ activeId }}</span>
            </div>

            <img src="/static/image/lotto/lottery-ticket.png" class="ticket-graphic" />

            <p class="hint-text">{{ $t('lotto.depositHint') }}</p>

            <div class="prize-boxes">
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.1stUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(firstPrizeUpTo, currentCurrency) }}</p>
              </div>
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.2ndUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(secondPrizeUpTo, currentCurrency) }}</p>
              </div>
              <div class="prize-box">
                <p class="prize-box-label">{{ $t('lotto.3rdUpTo') }}</p>
                <p class="prize-box-value">{{ currencyFormatter(thirdPrizeUpTo, currentCurrency) }}</p>
              </div>
            </div>
          </div>

          <div class="prize-boxes">
            <div class="prize-box">
              <p class="prize-box-label">{{ $t('lotto.4thUpTo') }}</p>
              <p class="prize-box-value">{{ currencyFormatter(specialPrizeUpTo, currentCurrency) }}</p>
            </div>
            <div class="prize-box">
              <p class="prize-box-label">{{ $t('lotto.5thUpTo') }}</p>
              <p class="prize-box-value">{{ currencyFormatter(consolationPrizeUpTo, currentCurrency) }}</p>
            </div>
          </div>

          <div class="horizontal-divider"></div>

          <div class="down-panel">
            <div>
              <p class="draw-closes-label">{{ $t('lotto.drawClosesIn') }}</p>

              <div class="countdown-boxes">
                <div class="countdown-box">{{ countdownHour }}</div>
                <span class="countdown-colon">:</span>
                <div class="countdown-box">{{ countdownMinute }}</div>
                <span class="countdown-colon">:</span>
                <div class="countdown-box">{{ countdownSecond }}</div>
              </div>
            </div>

            <div class="active-tickets">
              <p class="active-tickets-label">{{ $t('lotto.yourActiveTickets') }}</p>
              <p class="active-tickets-value">{{ walletBalances.active_tickets || 0 }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- marquee -->
      <div class="lotto-marquee-row">
        <div class="lotto-marquee-wrapper">
          <div class="lotto-marquee">
            <div class="lotto-marquee-content">
              <template v-for="activity in lottoTicketActivity">
              <span  class="pr-6 mr-6">
                <label class="d-inline-block home-announcment-content white--text">{{ activity.member_name }} got</label>
                <label class="d-inline-block home-announcment-content mx-1" style="color: #FFCE01 !important;">{{ activity.ticket_count }}</label>
                <label class="d-inline-block home-announcment-content white--text">ticket</label>
              </span>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- how to earn tickets -->
      <div class="tickets-section">
        <div>
          <p class="text-tickets">{{ $t(`lotto.howToEarnTickets`) }}</p>
        </div>
        <div class="tickets-list">
          <div class="tickets-box">
            <div class="tickets-header-row">
              <div class="ticket-text">
                <p>{{ $t(`lotto.depositToGetTickets`) }}</p>
                <p class="subtitle">{{ $t(`lotto.depositProgressHint`, [ticketSetting ? this.getCurrencyValue(ticketSetting.threshold_value, depositProgress.threshold_value): '0.00', ticketSetting ? this.getTicket(ticketSetting.tickets_to_grant, depositProgress.tickets_to_grant): 0]) }}</p>
              </div>
              <div class="bonus-badge">+{{ ticketSetting ? this.getTicket(ticketSetting.tickets_to_grant, depositProgress.tickets_to_grant): 0 }}</div>
            </div>
            <div class="progress-track">
              <div class="progress-fill" :style="{ width: `${getProgressValue(0, depositProgress.progress_pct)}%` }"></div>
            </div>

            <p class="progress-label">{{ ticketSetting ? this.getCurrencyValue(0, depositProgress.progress_value % depositProgress.threshold_value): '0.00' }} / {{ ticketSetting ? this.getCurrencyValue(ticketSetting.threshold_value, depositProgress.threshold_value): '0.00' }}</p>
          </div>
        </div>
      </div>

      <!-- winning -->
      <div class="winning-section" v-if="isLoggedIn">
        <div class="winning-box">
          <div>
            <p>{{ $t(`lotto.myWinnings`) }}:</p>
            <p class="winnings-amount">{{ currencyFormatter(walletBalances.unclaimed || 0, currentCurrency) }}</p>
          </div>
          <button class="btn-claim" @click="claimBalances()" :disabled="!isLoggedIn">{{ $t(`label.claim`) }}</button>
        </div>
        <div class="winning-box">
          <p>{{ $t(`lotto.lifetimeWinnings`) }}</p>
          <p class="winnings-amount">{{ currencyFormatter(walletBalances.total || 0, currentCurrency) }}</p>
        </div>
        <div class="winning-row">
          <div class="winning-box">
            <div>
              <p>{{ $t(`lotto.activeTickets`) }}:</p>
              <div class="active-tickets">
                <p class="active">{{ walletBalances.active_tickets || 0 }}</p>
              </div>
            </div>
          </div>
          <div class="winning-box">
            <div>
              <p>{{ $t(`lotto.lastDrawWinningTickets`) }}:</p>
              <p class="winnings-amount">{{ walletBalances.last_draw_winning_tickets || 0 }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- my tickets -->
      <div class="my-tickets-section" v-if="isLoggedIn">
        <p class="text-tickets">{{ $t('lotto.myTickets') }}</p>
        <div class="my-tickets-tabs">
          <div class="button-tabs">
            <button :class="{ active: subTab === 'active' }" @click="clickTicketsSubTab('active')">{{ $t(`lotto.active`) }}</button>
            <button :class="{ active: subTab === 'past' }" @click="clickTicketsSubTab('past')">{{ $t(`lotto.past`) }}</button>
          </div>
          <div v-if="subTab === 'past'" class="nav-bar ticket-past-nav-bar">
            <v-icon @click="prevTicketDate">mdi-chevron-left</v-icon>
            <div class="center-content">
              <v-menu offset-y max-height="300">
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="code-select">
                      <span>{{ currentTicketDate }} | {{ currentTicketCode }}</span>
                      <v-icon small>mdi-chevron-down</v-icon>
                    </span>
                </template>
                <v-list>
                  <v-list-item
                      v-for="(date, index) in pastTicketDateList"
                      :key="date.id"
                      @click="selectCode(index)"
                  >
                    <v-list-item-title>{{ date.drawDate }}|{{ date.id }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-icon @click="nextTicketDate">mdi-chevron-right</v-icon>
          </div>
        </div>

        <div class="my-tickets-info">
          <div v-if="subTab === 'active'" class="ticket-active" :class="activePagination.total > 0 ? '' : 'ticket-no-result'">
            <v-col v-if="activePagination.total === 0" class="no-result">
              <p>{{ $t(`lotto.depositEarnTicket`) }}</p>
              <p>{{ $t(`lotto.startDepositForTickets`) }}</p>
            </v-col>
            <v-col v-else cols="12" v-for="(a, index) in activeTicketList" :key="index" class="ticket-list">
              <div class="ticket-card">
                <div class="ticket-main">
                  <div class="ticket-badges">
                    <span class="badge badge--draw">{{ $t('lotto.inDraw') }}</span>
                    <span class="badge badge--type">{{ $t(`lotto.${a.numbers[0].match_type}`) }}</span>
                  </div>

                  <div class="ticket-digits">
                    <span
                        v-for="(digit, i) in String(a.numbers[0].number).split('')"
                        :key="i"
                        class="digit-box"
                    >{{ digit }}</span>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" style="float:right"
                                dark
                                v-bind="attrs"
                                v-on="on">
                          info
                        </v-icon>
                      </template>
                      <div>
                        <div v-for="(amount, prizeKey) in a.numbers[0].potential_winning" :key="prizeKey" style="font-size: 12px">
                          {{ $t(`lotto.${prizeKey}`) }}: {{ currencyFormatter(amount, currentCurrency) }}
                        </div>
                      </div>
                    </v-tooltip>
                  </div>

                  <p class="ticket-meta">
                    {{ a.draw_date }} | #{{ a.draw_id }}
                  </p>
                </div>

                <div class="ticket-divider"></div>

                <div class="ticket-chances">
                  <p class="chances-label">{{ $t('lotto.chances') }}</p>
                  <p class="chances-value">{{ a.numbers[0].permutations }}x</p>
                  <p class="chances-sub">{{ $t('lotto.permutations') }}</p>
                </div>
              </div>
            </v-col>
            <v-row no-gutters class="py-4" v-if="activePagination.last_page > 1">
              <v-col cols="12" class="text-center">
                <v-pagination
                    class="trxn_history_pagination"
                    v-model="activePagination.current_page"
                    :length="activePagination.last_page"
                    @input="changeActivePage"
                    :next-icon="'arrow_forward_ios'"
                    :prev-icon="'arrow_back_ios'"
                    :total-visible="10"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
          <div v-else-if="subTab === 'past'" class="ticket-past" :class="pastTicketList.length > 0 ? '' : 'ticket-no-result'">
            <v-col v-if="pastTicketList.length === 0" class="no-result">
              <p>{{ $t(`lotto.depositEarnTicket`) }}</p>
              <p>{{ $t(`lotto.startDepositForTickets`) }}</p>
            </v-col>

            <v-col cols="12" v-if="pastTicketList.length > 0" class="ticket-list">
              <div>
                <div class="text-your-ticket">
                  <p>{{ $t(`lotto.yourTicket`) }}</p>
                </div>
                <div class="ticket-permutations">
                  <p>{{ $t(`lotto.prize`) }}</p>
                </div>
              </div>
              <div class="ticket-next-draw">
                <p>
                  {{ $t(`lotto.amount`) }}
                </p>
              </div>
            </v-col>
            <v-col cols="12" v-for="(a, index) in pastTicketList" :key="index" class="ticket-list">
              <div>
                <div :class="a.numbers[0].match_type === 'miss' ? 'ticket-number': 'ticket-number-blue'">
                  <p>{{ a.numbers[0].number }}</p>
                </div>
                <div v-if="a.numbers[0].match_type === 'miss'" class="ticket-permutations">
                  <p>{{ $t(`lotto.${a.numbers[0].match_type}`) }}</p>
                </div>
                <div v-else class="ticket-permutations">
                  <p class="text-blue">{{ a.numbers[0].matched_number }} ({{ $t(`lotto.${a.numbers[0].prize_code}`) }})</p>
                  <p>{{ a.numbers[0].permutations }} {{ $t(`lotto.permutations`) }}</p>
                </div>
              </div>
              <div class="ticket-next-draw">
                <p :class="a.numbers[0].win_amount > 0 ? 'text-green' : ''">
                  {{ a.numbers[0].win_amount > 0 ? '+ ' : '' }}{{ currencyFormatter(a.numbers[0].win_amount, currentCurrency)}}
                </p>
              </div>
            </v-col>
            <v-row no-gutters class="py-4" v-if="pagination.last_page > 1">
              <v-col cols="12" class="text-center">
                <v-pagination
                    class="trxn_history_pagination"
                    v-model="pagination.current_page"
                    :length="pagination.last_page"
                    @input="changePage"
                    :next-icon="'arrow_forward_ios'"
                    :prev-icon="'arrow_back_ios'"
                    :total-visible="10"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

      <!-- last draw result -->
      <div class="last-draw-results">
        <div class="page-header">
          <p class="page-title">{{ $t('lotto.lastDrawResults') }}</p>
          <p class="page-subtitle">
            {{ getLastDrawLabel(this.lastDrawDate, this.lastHistoryId) }}
          </p>
        </div>

        <div class="match-banner">
          <img src="/static/image/lotto/icon-matches.png" class="match-icon" />
          <div class="match-text">
            <p class="match-title">
              {{ $t('lotto.matchedNumbers', [ lastHistoryMatches ]) }}
            </p>
            <!--            <p class="match-breakdown">{{ lastHistoryMatches }}</p>-->
          </div>
        </div>

        <div class="top-prizes-card">
          <div class="top-prize-row">
            <p class="top-prize-label first-prize-label">{{ $t(`lotto.1ST`) }}
              <span v-if="isTopPrizeMatched('1st_prize')" class="top-matched-star">★</span>
            </p>
            <div class="digit-boxes">
              <span
                  v-for="(digit, i) in String(this.lastFirstPrize).split('')"
                  :key="'1st-' + i"
                  class="digit-box"
                  :class="isTopPrizeMatched('1st_prize') ? 'matched-number': ''"
              >{{ digit }}</span>
            </div>
          </div>

          <div class="top-prize-row">
            <p class="top-prize-label second-prize-label">{{ $t(`lotto.2ND`) }}
              <span v-if="isTopPrizeMatched('2nd_prize')" class="top-matched-star">★</span>
            </p>
            <div class="digit-boxes">
              <span
                  v-for="(digit, i) in String(this.lastSecondPrize).split('')"
                  :key="'2nd-' + i"
                  class="digit-box"
                  :class="isTopPrizeMatched('2nd_prize') ? 'matched-number': ''"
              >{{ digit }}</span>
            </div>
          </div>

          <div class="top-prize-row">
            <p class="top-prize-label third-prize-label">{{ $t(`lotto.3RD`) }}
              <span v-if="isTopPrizeMatched('3rd_prize')" class="top-matched-star">★</span>
            </p>
            <div class="digit-boxes">
              <span
                  v-for="(digit, i) in String(this.lastThirdPrize).split('')"
                  :key="'3rd-' + i"
                  class="digit-box"
                  :class="isTopPrizeMatched('3rd_prize') ? 'matched-number': ''"
              >{{ digit }}</span>
            </div>
          </div>
        </div>

        <div class="prize-section">
          <div class="section-header">
            <p class="section-title">{{ $t('lotto.4TH') }}</p>
            <span class="count-badge">x{{ lastSpecialPrizes.length }}</span>
          </div>
          <div class="numbers-grid">
            <div
                v-for="(n, i) in lastSpecialPrizes"
                :key="'special-' + i"
                class="number-card"
                :class="lastMatchedSpecialIndexes.includes(i) ? 'matched-number': ''"
            >
              <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
              <span class="number-value">{{ n }}</span>
              <span v-if="lastMatchedSpecialIndexes.includes(i)" class="matched-star">★</span>
            </div>
          </div>
        </div>

        <div class="prize-section">
          <div class="section-header">
            <p class="section-title">{{ $t('lotto.5TH') }}</p>
            <span class="count-badge">x{{ lastConsolationPrizes.length }}</span>
          </div>
          <div class="numbers-grid">
            <div
                v-for="(n, i) in lastConsolationPrizes"
                :key="'consolation-' + i"
                class="number-card"
                :class="lastMatchedConsolationIndexes.includes(i) ? 'matched-number': ''"
            >
              <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
              <span class="number-value">{{ n }}</span>
              <span v-if="lastMatchedConsolationIndexes.includes(i)" class="matched-star">★</span>
            </div>
          </div>
        </div>
      </div>

      <!-- past result -->
      <div class="past-results-card">
        <div class="past-result-row">
          <p class="past-result-title">{{ $t('lotto.pastResults') }}</p>
          <div class="nav-bar ticket-past-nav-bar">
            <v-icon @click="prevResultDate">mdi-chevron-left</v-icon>
            <div class="center-content">
              <v-menu offset-y max-height="300">
                <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="code-select">
                            <span>{{ currentResultDate }} | {{ currentResultCode }}</span>
                            <v-icon small>mdi-chevron-down</v-icon>
                          </span>
                </template>
                <v-list>
                  <v-list-item
                      v-for="(date, index) in pastResultDateList"
                      :key="date.id"
                      @click="selectResultCode(index)"
                  >
                    <v-list-item-title>{{ date.drawDate }}|{{ date.id }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-icon @click="nextResultDate">mdi-chevron-right</v-icon>
          </div>
        </div>

        <div class="draw-row-wrapper">
          <div class="draw-summary-row">
            <div class="draw-date-info">
              <p class="draw-date">{{ this.currentResultDate }}</p>
              <p class="draw-id">#{{ this.currentResultCode }}</p>
            </div>

            <div class="draw-match-info">
              <span class="match-badge">
                {{ $t('lotto.match', [ pastMatches ]) }}
              </span>
            </div>
          </div>

          <div class="draw-expanded">
            <div class="draw-top-prizes">
              <div class="mini-prize">
                <p class="mini-prize-label first-prize-label">1st</p>
                <span class="mini-digit-box"
                      :class="isPastTopPrizeMatched('1st_prize') ? 'matched-number': ''">
                  {{ this.pastFirstPrize }}
                </span>
                <span v-if="isPastTopPrizeMatched('1st_prize')" class="top-matched-star">★</span>
              </div>
              <div class="mini-prize">
                <p class="mini-prize-label second-prize-label">2nd</p>
                <span class="mini-digit-box"
                      :class="isPastTopPrizeMatched('2nd_prize') ? 'matched-number': ''">
                  {{ this.pastSecondPrize }}
                </span>
                <span v-if="isPastTopPrizeMatched('2nd_prize')" class="top-matched-star">★</span>
              </div>
              <div class="mini-prize">
                <p class="mini-prize-label third-prize-label">3rd</p>
                <span class="mini-digit-box"
                      :class="isPastTopPrizeMatched('3rd_prize') ? 'matched-number': ''">
                  {{ this.pastThirdPrize }}
                </span>
                <span v-if="isPastTopPrizeMatched('3rd_prize')" class="top-matched-star">★</span>
              </div>
            </div>

            <div class="prize-section">
              <div class="prize-border">
                <div class="section-header">
                  <p class="section-title">{{ $t('lotto.4TH') }}</p>
                  <span class="count-badge">x{{ pastSpecialPrizes.length }}</span>
                </div>
                <div class="numbers-grid">
                  <div
                      v-for="(n, i) in pastConsolationPrizes"
                      :key="'special-' + i"
                      class="number-card"
                      :class="pastMatchedSpecialIndexes.includes(i) ? 'matched-number': ''"
                  >
                    <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
                    <span class="number-value">{{ n }}</span>
                    <span v-if="pastMatchedSpecialIndexes.includes(i)" class="matched-star">★</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="prize-section">
              <div class="prize-border">
                <div class="section-header">
                  <p class="section-title">{{ $t('lotto.5TH') }}</p>
                  <span class="count-badge">x{{ pastConsolationPrizes.length }}</span>
                </div>
                <div class="numbers-grid">
                  <div
                      v-for="(n, i) in pastConsolationPrizes"
                      :key="'consolation-' + i"
                      class="number-card"
                      :class="pastMatchedConsolationIndexes.includes(i) ? 'matched-number': ''"
                  >
                    <span class="number-index">{{ String(i + 1).padStart(2, '0') }}</span>
                    <span class="number-value">{{ n }}</span>
                    <span v-if="pastMatchedConsolationIndexes.includes(i)" class="matched-star">★</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- faq -->
      <div class="faq-section">
        <div>
          <p class="text-rules">{{ $t(`lotto.faq`) }}</p>
        </div>
        <div class="accordion">
          <div
              v-for="(item, index) in faqItems"
              :key="index"
              class="accordion-item"
          >
            <div class="accordion-header" @click="toggle(index)">
              <span>{{ $t(item.title) }}</span>
              <span class="arrow" :class="{ open: openIndex === index }">▼</span>
            </div>
            <div v-show="openIndex === index" class="accordion-body">
              <p v-html="$t(item.content)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SESSION, SHARED} from '@/constants/constants'
import {ROUTE_NAME} from '@/constants/route.constants'
import {locale, uiHelper} from '@/util'
import {
  LOTTO_GET_ACTIVITY,
  LOTTO_GET_DRAWS_CURRENT,
  LOTTO_GET_DRAWS_HISTORY,
  LOTTO_GET_DRAWS_LAST_HISTORY,
  LOTTO_GET_DRAWS_LAST_RESULTS,
  LOTTO_GET_DRAWS_PAST_RESULTS,
  LOTTO_GET_DRAWS_RESULTS,
  LOTTO_GET_HISTORY_MATCHES,
  LOTTO_GET_MEMBER_PROGRESS,
  LOTTO_GET_PAST_MATCHES,
  LOTTO_GET_PROGRESS,
  LOTTO_GET_TICKETS,
  LOTTO_GET_TICKETS_HISTORY,
  LOTTO_GET_TICKETS_SETTINGS,
  LOTTO_GET_WALLET_BALANCE,
  LOTTO_POST_WALLET_CLAIM
} from '@/store/lotto.module'
import {REFERRAL_GET_OVERVIEW} from "@/store/referral.module";
import currencyFormat from "@/filters/currency-format";

export default {
  name: 'lotto',
  data: () => ({
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    routeName: ROUTE_NAME,
    language: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    currencyFormatter: currencyFormat,
    current: {},
    results: {},
    firstPrize: '0000',
    secondPrize : '0000',
    thirdPrize : '0000',
    specialPrizes: Array(10).fill('0000'),
    consolationPrizes: Array(10).fill('0000'),
    countdown: "00:00:00",
    countdownHour: "00",
    countdownMinute: "00",
    countdownSecond: "00",
    walletBalances: {},
    walletClaims: {},
    depositProgress: {},
    turnoverProgress: {},
    milestoneProgress: {},
    turnoverAccumulated: '0.00',
    turnoverThreshold: '0.00',
    history: {},
    lastHistoryId: 0,
    lastDrawDate: '',
    lastDrawTime: '',
    referCode: '',
    referLink: '',
    openIndex: null,
    faqItems: [
      { title: "lotto.faq1", content: "lotto.faq1a" },
      { title: "lotto.faq2", content: "lotto.faq2a" },
      { title: "lotto.faq3", content: "lotto.faq3a" },
      { title: "lotto.faq4", content: "lotto.faq4a" },
      { title: "lotto.faq5", content: "lotto.faq5a" },
      { title: "lotto.faq6", content: "lotto.faq6a" },
      { title: "lotto.faq7", content: "lotto.faq7a" },
      { title: "lotto.faq8", content: "lotto.faq8a" },
      { title: "lotto.faq9", content: "lotto.faq9a" },
      { title: "lotto.faq10", content: "lotto.faq10a" }
    ],
    activeTab: "tickets",
    subTab: "active",
    activeId: 0,
    activeTickets: 0,
    activeTicketList: [],
    pastTicketList: [],
    currentTicketIndex: 0,
    currentTicketDate: "",
    currentTicketCode: "",
    pastTicketDateList: [],
    pastMatches: 0,
    pastResults: {},
    pastFirstPrize: '0000',
    pastSecondPrize : '0000',
    pastThirdPrize : '0000',
    pastSpecialPrizes: Array(10).fill('0000'),
    pastConsolationPrizes: Array(10).fill('0000'),
    currentResultIndex: 0,
    currentResultDate: "",
    currentResultCode: "",
    pastResultDateList: [],
    activePagination: {
      currentPage: 1,
      totalPage: 1,
      paginationPageLimit: 20
    },
    selectedActivePage: 1,
    pagination: {
      currentPage: 1,
      totalPage: 1,
      paginationPageLimit: 20
    },
    selectedPage: 1,
    ticketSetting: {},
    alertShow: false,
    alertSuccess: false,
    alertMessage: "",
    firstPrizeUpTo: '10000.00',
    secondPrizeUpTo: '4000.00',
    thirdPrizeUpTo: '1500.00',
    specialPrizeUpTo: '750.00',
    consolationPrizeUpTo: '150.00',
    lastHistoryMatches: 0,
    lastResults: {},
    lastFirstPrize: '0000',
    lastSecondPrize : '0000',
    lastThirdPrize : '0000',
    lastSpecialPrizes: Array(10).fill('0000'),
    lastConsolationPrizes: Array(10).fill('0000'),
    lastMyWins: {},
    lastMatchedSpecialIndexes: [],
    lastMatchedConsolationIndexes: [],
    pastMyWins: {},
    pastMatchedSpecialIndexes: [],
    pastMatchedConsolationIndexes: [],
    lottoTicketActivity: []
  }),
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    drawsCurrent() {
      return this.$store.state.lotto.drawsCurrent
    },
    drawsResults() {
      return this.$store.state.lotto.drawsResults
    },
    drawsPastResults() {
      return this.$store.state.lotto.drawsPastResults
    },
    walletBalance() {
      return this.$store.state.lotto.walletBalance
    },
    walletClaim() {
      return this.$store.state.lotto.walletClaim
    },
    lottoProgress() {
      return this.$store.state.lotto.progress
    },
    drawsLastHistory() {
      return this.$store.state.lotto.drawsLastHistory
    },
    drawsHistory() {
      return this.$store.state.lotto.drawsHistory
    },
    lottoTickets() {
      return this.$store.state.lotto.tickets.data
    },
    lottoTicketsPagination() {
      return this.$store.state.lotto.tickets.pagination
    },
    lottoMemberProgress() {
      return this.$store.state.lotto.memberProgress
    },
    lottoTicketsHistory() {
      return this.$store.state.lotto.ticketsHistory.data
    },
    lottoTicketsHistoryPagination() {
      return this.$store.state.lotto.ticketsHistory.pagination
    },
    lottoTicketsSettings() {
      return this.$store.state.lotto.ticketSettings.data
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },
    drawsLastHistoryMatches() {
      return this.$store.state.lotto.historyMatches
    },
    drawsLastResults() {
      return this.$store.state.lotto.drawsLastResults
    },
    drawsPastMatches() {
      return this.$store.state.lotto.pastMatches
    },
    lottoActivity() {
      return this.$store.state.lotto.activity.data
    },
  },
  watch: {
    isLoggedIn() {
      this.getWalletBalance()
      this.getReferCode()
      this.getLottoProgress()
      this.getLottoMemberProgress()
    },
    drawsCurrent() {
      this.current = this.$store.state.lotto.drawsCurrent
      let seconds = this.getDiffSeconds(this.current.draw_time);
      // one countdown at a time: a new draw replaces the old timer instead of running beside it
      clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        if (seconds > 0) {
          seconds--;
          const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
          const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
          const s = String(seconds % 60).padStart(2, "0");
          // this.countdown = `${h}:${m}:${s}`;
          this.countdownHour = h;
          this.countdownMinute = m;
          this.countdownSecond = s;
        }
      }, 1000);

      if(this.current.status === 'settled') {
        this.lastHistoryId = this.current.id
        this.lastDrawDate = this.current.draw_date
        this.lastDrawTime = this.current.draw_time
        this.getDrawResult(this.current.id)
        this.getLottoTicketsHistory(this.current.id)
        this.getLottoHistoryMatches(this.current.id)
        this.getDrawPastResult(this.current.id - 1)
        this.getDrawLastResult(this.current.id)
        this.getLottoPastMatches(this.current.id)
        this.activeId = this.current.id + 1
      } else {
        this.activeId = this.current.id
        this.getDrawLastHistory()
      }

      // this.activeId = this.current.id
      this.getLottoTickets(this.activeId)
      this.getDrawHistory()
    },
    drawsResults() {
      let data = this.$store.state.lotto.drawsResults.data
      this.results = data.results

      this.lastHistoryId = data.draw.id
      this.lastDrawDate = data.draw.draw_date
      this.lastDrawTime = data.draw.draw_time
      this.firstPrize = this.results.find(r => r.prize_code === '1st_prize')?.number
      this.secondPrize = this.results.find(r => r.prize_code === '2nd_prize')?.number
      this.thirdPrize = this.results.find(r => r.prize_code === '3rd_prize')?.number
      this.specialPrizes = this.results.filter(r => r.prize_code === '4th_prize').map(r => r.number)
      this.consolationPrizes = this.results.filter(r => r.prize_code === '5th_prize').map(r => r.number)
    },
    walletBalance() {
      this.walletBalances = this.$store.state.lotto.walletBalance.data
    },
    walletClaim() {
      let response = this.$store.state.lotto.walletClaim;
      if (response.complete) {
        if(response.success) {
          this.openAlert(response.success, locale.getMessage('lotto.successfullyClaimed', [response.data.claimed_amount]));
          this.getWalletBalance()
        } else if (response.code === 2) {
          this.openAlert(response.success, locale.getMessage('lotto.unableToClaimContactSupport'));
        } else {
          this.openAlert(response.success, locale.getMessage('lotto.noUnclaimedWinningsFound'));
        }
      }
    },
    lottoProgress() {
      let progress = this.$store.state.lotto.progress.data

      // this.depositProgress = progress.find(r => r.source === 'deposit' && r.rule_type === 'base') || { threshold: 0, tickets_to_grant: 0 }
      // this.turnoverProgress = progress.find(r => r.source === 'turnover' && r.rule_type === 'base') || { threshold: 0, tickets_to_grant: 0 }
      // this.milestoneProgress = progress.filter(r => r.source === 'turnover' && r.rule_type === 'milestone')
      // this.turnoverAccumulated = this.milestoneProgress[0].accumulated
      // this.turnoverThreshold = this.getNextThreshold(this.turnoverAccumulated, this.milestoneProgress)
    },
    drawsLastHistory() {
      this.lastHistoryId = this.$store.state.lotto.drawsLastHistory.data[0]?.id
      if(this.lastHistoryId) {
        this.getDrawResult(this.lastHistoryId)
        this.getLottoTicketsHistory(this.lastHistoryId)
        this.getLottoHistoryMatches(this.lastHistoryId)
        this.getDrawPastResult(this.lastHistoryId - 1)
        this.getDrawLastResult(this.lastHistoryId)
        this.getLottoPastMatches(this.lastHistoryId)
      }
    },
    drawsHistory() {
      this.history = this.$store.state.lotto.drawsHistory.data
      this.currentTicketIndex = 0
      this.currentTicketDate = this.history[0]?.draw_date
      this.currentTicketCode = this.history[0]?.id
      this.pastTicketDateList = this.history.map(item => ({
        id: item.id,
        drawDate: item.draw_date
      }));
      this.currentResultIndex = 1
      this.currentResultDate = this.history[1]?.draw_date
      this.currentResultCode = this.history[1]?.id
      this.pastResultDateList = this.history.map(item => ({
        id: item.id,
        drawDate: item.draw_date
      }));
    },
    drawsLastHistoryMatches() {
      let data = this.$store.state.lotto.historyMatches.data
      this.lastHistoryMatches = data?.[0]?.match_count ?? 0
    },
    drawsPastMatches() {
      let data = this.$store.state.lotto.pastMatches.data
      this.pastMatches = data?.[0]?.match_count ?? 0
    },
    drawsPastResults() {
      let data = this.$store.state.lotto.drawsPastResults.data
      this.pastResults = data.results
      this.pastMyWins = data.my_wins

      this.pastFirstPrize = this.pastResults.find(r => r.prize_code === '1st_prize')?.number
      this.pastSecondPrize = this.pastResults.find(r => r.prize_code === '2nd_prize')?.number
      this.pastThirdPrize = this.pastResults.find(r => r.prize_code === '3rd_prize')?.number
      this.pastSpecialPrizes = this.pastResults.filter(r => r.prize_code === '4th_prize').map(r => r.number)
      this.pastConsolationPrizes = this.pastResults.filter(r => r.prize_code === '5th_prize').map(r => r.number)

      const winsArray = Array.isArray(this.pastMyWins) ? this.pastMyWins : [];
      const winKeys = new Set(
          winsArray.map(w => `${w.prize_code}_${this.normalizeDigits(w.number)}`)
      );
      this.pastMatchedSpecialIndexes = this.pastResults
          .filter(r => r.prize_code === '4th_prize')
          .reduce((acc, r, i) => {
            if (winKeys.has(`${r.prize_code}_${this.normalizeDigits(r.number)}`)) acc.push(i);
            return acc;
          }, []);

      this.pastMatchedConsolationIndexes = this.pastResults
          .filter(r => r.prize_code === '5th_prize')
          .reduce((acc, r, i) => {
            if (winKeys.has(`${r.prize_code}_${this.normalizeDigits(r.number)}`)) acc.push(i);
            return acc;
          }, []);
    },
    drawsLastResults() {
      let data = this.$store.state.lotto.drawsLastResults.data
      this.lastResults = data.results
      this.lastMyWins = data.my_wins

      this.lastFirstPrize = this.lastResults.find(r => r.prize_code === '1st_prize')?.number
      this.lastSecondPrize = this.lastResults.find(r => r.prize_code === '2nd_prize')?.number
      this.lastThirdPrize = this.lastResults.find(r => r.prize_code === '3rd_prize')?.number
      this.lastSpecialPrizes = this.lastResults.filter(r => r.prize_code === '4th_prize').map(r => r.number)
      this.lastConsolationPrizes = this.lastResults.filter(r => r.prize_code === '5th_prize').map(r => r.number)

      const winsArray = Array.isArray(this.lastMyWins) ? this.lastMyWins : [];
      const winKeys = new Set(
          winsArray.map(w => `${w.prize_code}_${this.normalizeDigits(w.number)}`)
      );
      this.lastMatchedSpecialIndexes = this.lastResults
          .filter(r => r.prize_code === '4th_prize')
          .reduce((acc, r, i) => {
            if (winKeys.has(`${r.prize_code}_${this.normalizeDigits(r.number)}`)) acc.push(i);
            return acc;
          }, []);

      this.lastMatchedConsolationIndexes = this.lastResults
          .filter(r => r.prize_code === '5th_prize')
          .reduce((acc, r, i) => {
            if (winKeys.has(`${r.prize_code}_${this.normalizeDigits(r.number)}`)) acc.push(i);
            return acc;
          }, []);
    },
    lottoTickets() {
      this.activeTicketList = this.$store.state.lotto.tickets.data
    },
    lottoTicketsPagination() {
      this.activePagination = this.lottoTicketsPagination
    },
    lottoTicketsHistory() {
      this.pastTicketList = this.$store.state.lotto.ticketsHistory.data
    },
    lottoTicketsHistoryPagination() {
      this.pagination = this.lottoTicketsHistoryPagination
    },
    lottoMemberProgress() {
      let memberProgress = this.$store.state.lotto.memberProgress.data

      this.depositProgress = memberProgress.progress.find(r => r.type === 'deposit')
      // this.turnoverProgress = progress.find(r => r.source === 'turnover' && r.rule_type === 'base')
      // this.milestoneProgress = progress.filter(r => r.source === 'turnover' && r.rule_type === 'milestone')
      // this.turnoverAccumulated = this.milestoneProgress[0].accumulated
      // this.turnoverThreshold = this.getNextThreshold(this.turnoverAccumulated, this.milestoneProgress)
    },
    lottoTicketsSettings() {
      let ticketSettings = this.$store.state.lotto.ticketSettings.data

      this.ticketSetting = ticketSettings.find(r => r.type === 'deposit')
    },
    lottoActivity() {
      this.lottoTicketActivity = this.$store.state.lotto.activity.data;
    },
    referralOverview() {
      if (!_.isEmpty(this.$store.state.referral.overview)) {
        this.referCode = this.$store.state.referral.overview.my_referral_code
        this.referLink = uiHelper.getHostname() + '?refer_code=' + this.referCode
      }
    }
  },
  mounted() {

  },
  created() {
    this.getLottoOverview()
    if(this.isLoggedIn) {
      this.getWalletBalance()
      this.getReferCode()
      this.getLottoProgress()
      this.getLottoMemberProgress()
    }
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer)
  },
  methods: {
    normalizeDigits(num) {
      return String(num).split('').sort().join('');
    },
    isTopPrizeMatched(prizeCode) {
      const wins = Array.isArray(this.lastMyWins) ? this.lastMyWins : [];
      return wins.some(w => w.prize_code === prizeCode);
    },
    isPastTopPrizeMatched(prizeCode) {
      const wins = Array.isArray(this.pastMyWins) ? this.pastMyWins : [];
      return wins.some(w => w.prize_code === prizeCode);
    },
    clickTicketsSubTab(subTab) {
      this.subTab = subTab
    },
    changeActivePage(targetPage) {
      this.selectedActivePage = targetPage
      this.getLottoTickets(this.activeId)
    },
    changePage(targetPage) {
      this.selectedPage = targetPage
      this.getLottoTicketsHistory(this.currentTicketCode)
    },
    prevResultDate() {
      if (this.currentResultIndex  < this.pastResultDateList.length - 1) {
        this.selectResultCode(this.currentResultIndex + 1)
      }
    },
    nextResultDate() {
      if (this.currentResultIndex > 0) {
        this.selectResultCode(this.currentResultIndex - 1)
      }
    },
    selectResultCode(index) {
      const date = this.pastResultDateList[index];
      if(date) {
        this.currentResultIndex = index;
        this.currentResultDate = date.drawDate
        this.currentResultCode = date.id;
        this.getDrawPastResult(this.currentResultCode)
        this.getLottoPastMatches(this.currentResultCode)
      }
    },
    prevTicketDate() {
      if (this.currentTicketIndex  < this.pastTicketDateList.length - 1) {
        this.selectCode(this.currentTicketIndex + 1)
      }
    },
    nextTicketDate() {
      if (this.currentTicketIndex > 0) {
        this.selectCode(this.currentTicketIndex - 1)
      }
    },
    selectCode(index) {
      const date = this.pastTicketDateList[index];
      if(date) {
        this.selectedPage = 1
        this.currentTicketIndex = index;
        this.currentTicketDate = date.drawDate
        this.currentTicketCode = date.id;
        this.getLottoTicketsHistory(this.currentTicketCode)
      }
    },
    openAlert(success, msg) {
      this.alertSuccess = success;
      this.alertMessage = msg;
      this.alertShow = true;
    },
    getLottoOverview() {
      this.getDrawsCurrent();
      this.getLottoTicketsSettings();
      this.getLottoActivity()
    },
    getDrawsCurrent() {
      this.$store.dispatch(`${LOTTO_GET_DRAWS_CURRENT}`)
    },
    getDrawResult(id) {
      let obj = {
        id: id
      }
      this.$store.dispatch(`${LOTTO_GET_DRAWS_RESULTS}`, { obj })
    },
    getDrawPastResult(id) {
      let obj = {
        id: id
      }
      this.$store.dispatch(`${LOTTO_GET_DRAWS_PAST_RESULTS}`, { obj })
    },
    getDrawLastResult(id) {
      let obj = {
        id: id
      }
      this.$store.dispatch(`${LOTTO_GET_DRAWS_LAST_RESULTS}`, { obj })
    },
    getWalletBalance() {
      this.$store.dispatch(`${LOTTO_GET_WALLET_BALANCE}`)
    },
    getDrawLastHistory() {
      this.$store.dispatch(`${LOTTO_GET_DRAWS_LAST_HISTORY}`)
    },
    getLottoProgress() {
      this.$store.dispatch(`${LOTTO_GET_PROGRESS}`)
    },
    getDrawHistory() {
      this.$store.dispatch(`${LOTTO_GET_DRAWS_HISTORY}`)
    },
    getLottoTickets(id) {
      let obj = {
        id: id,
        page: this.selectedActivePage
      }
      this.$store.dispatch(`${LOTTO_GET_TICKETS}`, { obj })
    },
    getLottoTicketsHistory(id) {
      let obj = {
        id: id,
        page: this.selectedPage,
      }
      this.$store.dispatch(`${LOTTO_GET_TICKETS_HISTORY}`, { obj })
    },
    getLottoHistoryMatches(id) {
      let obj = {
        draw_ids: id
      }
      this.$store.dispatch(`${LOTTO_GET_HISTORY_MATCHES}`, { obj })
    },
    getLottoPastMatches(id) {
      let obj = {
        draw_ids: id
      }
      this.$store.dispatch(`${LOTTO_GET_PAST_MATCHES}`, { obj })
    },
    getLottoMemberProgress() {
      let obj = {
        member_code: localStorage.getItem(SESSION.USERNAME),
        type: 'deposit'
      }
      this.$store.dispatch(`${LOTTO_GET_MEMBER_PROGRESS}`, { obj })
    },
    getReferCode() {
      if (!_.isEmpty(this.$store.state.referral.overview)) {
        this.referCode = this.$store.state.referral.overview.my_referral_code
        this.referLink = uiHelper.getHostname() + '?refer_code=' + this.referCode
      } else {
        this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
      }
    },
    getDiffSeconds(drawTimeStr) {
      const timeZone = "Asia/Dhaka";
      const now = new Date(new Date().toLocaleString("en-US", { timeZone }));

      const [h, m, s] = drawTimeStr.split(":").map(Number);
      let target = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          h,
          m,
          s
      );
      if (target < now) {
        target.setDate(target.getDate() + 1);
      }
      return Math.floor((target - now) / 1000);
    },
    getNextThreshold(turnoverAccumulated, milestoneProgress) {
      const bigger = milestoneProgress
          .filter(item => item.threshold > turnoverAccumulated)
          .sort((a, b) => a.threshold - b.threshold);

      if (bigger.length > 0) {
        return bigger[0].threshold;
      } else {
        return Math.max(...milestoneProgress.map(item => item.threshold));
      }
    },
    copyRefCode() {
      let $f = this
      if (this.referCode !== '') {
        this.$copyText(this.referCode).then(function(e) {
          $f.alertMessage = 'Referral Code Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    },
    copyReferralLink() {
      let $f = this
      if (this.referLink !== '') {
        this.$copyText(this.referLink).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    },
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    naviToDeposit() {
      if (!this.isLoggedIn) {
        this.$parent.goToLoginPage()
      } else {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            lang: this.$route.params.lang
          }
        })
      }
    },
    claimBalances() {
      this.$store.dispatch(`${LOTTO_POST_WALLET_CLAIM}`)
    },
    getLottoTicketsSettings() {
      this.$store.dispatch(`${LOTTO_GET_TICKETS_SETTINGS}`)
    },
    getLottoActivity() {
      this.$store.dispatch(`${LOTTO_GET_ACTIVITY}`)
    },
    getCurrencyValue(defaultValue, overrideValue) {
      return this.currencyFormatter(
          overrideValue ?? defaultValue ?? 0,
          this.currentCurrency
      )
    },
    getProgressValue(defaultValue, overrideValue) {
      return overrideValue ?? defaultValue ?? 0
    },
    getTicket(defaultTicket, overrideTicket) {
      return overrideTicket ?? defaultTicket ?? 0
    },
    getWinnerOfDayLabel(drawDate) {
      const parts = (drawDate || '').replace(/\//g, '-').split('-')
      const day = Number(parts[2]) || new Date().getDate()
      const month = Number(parts[1]) || (new Date().getMonth() + 1)
      return `${this.$t(`lotto.winnerOfTheDay`)} ${day}/${month}`
    },
    getLastDrawLabel(drawDate, drawCode) {
      return `${this.$t(`lotto.lastDrawDateCode`, [drawDate, drawCode])}`

    }
  }
}
</script>

<style lang="scss">
.profile-alert-success {
  .v-icon {
    color: #25b34b;
  }
}
.profile-alert-failed {
  .v-icon {
    color: #dc2d2d;
  }
}

.margin-lotto-desktop {
  margin: 0px 12%;
  padding: 0px !important;

  .lotto-marquee-row {
    padding: 0 7px !important;
  }

  .lotto-marquee-wrapper {
    display: flex;
    align-items: center;
    max-width: 100%;
    min-width: 100%;
    margin: auto;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background-color: #333333;
  }

  .lotto-marquee {
    height: 30px;
    border: none;
    border-radius: 0px !important;
    background-color: transparent !important;

    span {
      label {
        color: white !important;
        font-size: 13px;
        line-height: 30px;
      }
    }
  }

  .lotto-marquee-content {
    display: inline-block;
    white-space: nowrap;
    animation: scroll-left-desktop 160s linear infinite;
  }

  @keyframes scroll-left-desktop {
    from { transform: translateX(0vw); }
    to   { transform: translateX(-100%); }
  }

  .home-banner-box label {
    color: #fddd04;
  }
  .home-announcment-content span {
    color: #fddd04 !important;
  }

  .lottery-wrapper {
    font-family: inherit;

    .lottery-title {
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 10px;
      letter-spacing: 0.3px;
    }

    .lottery-card {
      display: flex;
      align-items: stretch;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #eceef1;
      padding: 20px 24px;
      margin-bottom: 12px;
    }

    .left-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .subtitle {
      margin: 0;
      font-size: 12px;
      color: #8a8f98;
    }

    .ticket-graphic {
      display: block;
      width: 220px;
      height: auto;
      border-radius: 8px;
    }

    .hint-text {
      margin: 2px 0 4px;
      font-weight: bold;
      font-size: 13px;
      color: #000000;
    }

    .prize-boxes {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }

    .prize-box {
      min-width: 104px;
      background: #FFF3C0;
      border-radius: 6px;
      padding: 8px 10px;
    }

    .prize-box-label {
      margin: 0 0 4px;
      font-size: 8px;
      color: #6E6E6E;
      line-height: 1.3;
    }

    .prize-box-value {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #000000;
    }

    .vertical-divider {
      width: 1px;
      background: #eceef1;
      margin: 0 28px;
    }

    .right-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 200px;
    }

    .ticket-id {
      align-self: flex-end;
      font-size: 12px;
      color: #8a8f98;
    }

    .draw-closes-label {
      margin: 8px 0 10px;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 0.3px;
    }

    .countdown-boxes {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 18px;
    }

    .countdown-box {
      width: 56px;
      height: 56px;
      text-align: center;
      align-content: center;
      border-radius: 4px;
      background: #f4f4f4;
      color: #0C8CE9;
      font-size: 28px;
      font-weight: 700;
      font-variant-numeric: tabular-nums;
    }

    .countdown-colon {
      color: #000000;
      font-size: 18px;
      font-weight: 700;
    }

    .active-tickets {
      border-top: 1px solid #eceef1;
      padding-top: 12px;
    }

    .active-tickets-label {
      margin: 0 0 4px;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 0.3px;
    }

    .active-tickets-value {
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      color: #FFCE01;
    }

    .winners-ticker {
      margin-top: 10px;
      background: #1a1a1a;
      border-radius: 8px;
      overflow: hidden;
      padding: 8px 0;
    }

    .ticker-track {
      display: flex;
      gap: 32px;
      white-space: nowrap;
      animation: ticker-scroll 22s linear infinite;
    }

    .ticker-item {
      font-size: 12px;
      color: #d8d8d8;
    }

    @keyframes ticker-scroll {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }
  }


  .lottery-banner-section {
    display: flex;
    background-image: url('/static/image/lotto/banner-bg.jpg');
    border-radius: 8px;
    background-size: cover;
    background-position-x: center;

    .prizes-list {
      width: 400px;
      margin: 20px;
    }

    .game-info {
      display: flex;
      justify-content: space-between;

      p{
        font-size: 16px;
        font-weight: bolder;
        color: #6E6E6E;
      }
    }

    .prizes, .prizes-number {
      display: flex;
      font-weight: bold;
      margin: 6px 0;
      gap: 8px;

      .first-prize {
        font-size: 14px;
        background-color: #FFCE01;
      }

      .second-prize {
        font-size: 14px;
        background-color: #FFE36C;
      }

      .third-prize {
        font-size: 14px;
        background-color: #FFF1B4;
      }

      div {
        flex: 1;
        border-radius: 4px;
        height: 32px;
        align-content: center;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }
    }

    .other-prizes {
      margin-bottom: 16px;

      .prizes {
        border-radius: 4px;
        height: 32px;
        justify-content: center;
        align-items: center;
        margin: 8px 0;
        font-size: 12px;
        font-weight: bold;
        color: white;
        background-color: black;
      }

      .number-list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        //gap: 10px;

        span {
          font-size: 16px;
          text-align: center;
          color: black;
        }
      }
    }

    .vertical-divider {
      border-left: 2px dotted #ccc;
      min-height: 100%;
      margin: 20px 0;
    }

    .countdown {
      margin-left: 80px;
      text-align: center;
      align-content: center;
      color: black;

      .next-draw {
        font-size: 16px;
        margin: 0;
      }

      .countdown-time {
        font-size: 36px;
        font-weight: bolder;
        margin-bottom: 8px;
      }

      .btn-earn-ticket {
        width: 144px;
        height: 40px;
        background: #FFCE01;
        border-radius: 6px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: black;
        padding: 8px;
        white-space: nowrap;
      }

      .btn-earn-ticket:disabled {
        background-color: #ccc;
        color: #666;
        cursor: default;
        opacity: 0.7;
      }
    }
  }

  .winning-section {
    display: flex;
    gap: 12px;
    margin: 12px 0;

    .winning-box {
      flex: 1;
      display: flex;
      height: 96px;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 0 16px;
      background: #fff;

      p {
        font-size: 12px;
        color: black;
        margin-bottom: 4px;
      }

      .winnings-amount {
        font-size: 20px;
      }

      .btn-claim {
        width: 120px;
        height: 40px;
        background: #FFCE01;
        border-radius: 6px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: black;
      }

      .btn-claim:disabled {
        background-color: #ccc;
        color: #666;
        cursor: default;
        opacity: 0.7;
      }

      .active-tickets {
        display: flex;

        p {
          font-size: 20px;
        }

        .active {
          color: #FFCE01;
        }
      }
    }
  }

  //.deposit-progress-card {
  //  background: #ffffff;
  //  border-radius: 10px;
  //  border: 1px solid #eceef1;
  //  padding: 16px 20px;
  //
  //
  //  .header-row {
  //    display: flex;
  //    align-items: flex-start;
  //    justify-content: space-between;
  //    gap: 12px;
  //    margin-bottom: 14px;
  //  }
  //
  //  .title {
  //    margin: 0 0 4px;
  //    font-size: 14px;
  //    font-weight: 700;
  //    color: #1a1a1a;
  //  }
  //
  //  .subtitle {
  //    margin: 0;
  //    font-size: 12px;
  //    color: #8a8f98;
  //  }
  //

  //}


  .tickets-section {
    gap: 12px;
    margin: 12px 0;
    .text-tickets {
      font-size: 16px;
      font-weight: bolder;
    }

    .tickets-list {
      display: flex;
      gap: 12px;
      margin: 12px 0;
      .tickets-box {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 120px;
        justify-content: space-between;
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 12px 16px;
        background: #fff;

        .tickets-header-row {
          flex: 1;
          display: flex;
          justify-content: space-between;
        }

        .ticket-text {
          p {
            font-size: 14px;
            color: black;
            margin-bottom: 0px;
          }

          .subtitle {
            font-size: 12px;
            color: #6e6e6e;
          }

          .ticket-number {
            font-size: 18px;
            color: #FFCE01;
          }

          .text-refer {
            font-size: 12px;
            font-weight: bold;
          }

          .text-refer-desc {
            font-size: 10px;
          }
        }

        .bonus-badge {
          flex-shrink: 0;
          height: 56px;
          text-align: center;
          align-content: center;
          border-radius: 8px;
          background: #FFF3C0;
          color: #FFCE01;
          font-size: 28px;
          padding: 0 8px;
          font-weight: 700;
        }

        .refer-box {
          display: flex;
          width: 50%;
          justify-content: end;
          gap: 8px;

          .border-referral {
            width: 144px;
            height: 40px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            align-items: center;
            background-color: #D9D9D9;

            .v-input__slot {
              padding: 8px;

              .v-input__append-inner {
                width: 36px;
              }
            }
          }

          .btn-refer-now {
            width: 120px;
            height: 40px;
            background: #FFCE01;
            border-radius: 6px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            color: black;
          }
        }

        .img-ticket {
          width: 92px;
        }

        .progress-track {
          position: relative;
          width: 100%;
          min-height: 8px;
          border-radius: 999px;
          background: #D9D9D9;
          overflow: hidden;
          margin: 8px 0px;
        }

        .progress-fill {
          min-height: 8px;
          border-radius: 999px;
          background: #FFCE01;
          transition: width 0.3s ease;
        }

        .progress-label {
          margin: 0;
          font-size: 12px;
          color: #000000;
        }
      }

      .daily-box {
        flex: 1;
        height: 120px;
        align-content: center;
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 0 16px;
        background: #fff;

        >div {
          display: flex;
          justify-content: space-between;
        }
        .daily-text {
          .text-daily {
            font-size: 12px;
            font-weight: bold;
            margin-bottom: 0;
          }

          .text-daily-desc {
            font-size: 12px;
            margin-bottom: 0;
          }
        }

        .daily-amount {
          font-size: 20px;
          font-weight: bold;
        }

        .daily-progress-bar {
          display: flex;
          width: 100%;
          gap: 28px;

          .step {
            flex: 1;
            height: 40px;
            position: relative;
            padding: 12px;
            text-align: center;
            color: #000;
            font-weight: bold;
          }

          .step:last-child::after {
            display: none;
          }

          .completed {
            background: #FFCE01;
            color: #000;
          }

          .completed::after {
            content: "";
            position: absolute;
            top: 0;
            right: -20px;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #FFCE01;
            z-index: 1;
          }

          .dark {
            background: black;
            color: #fff;
          }

          .dark::after {
            content: "";
            position: absolute;
            top: 0;
            right: -20px;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid black;
            z-index: 1;
          }

          .light {
            background: #D9D9D9;
            color: #6E6E6E;
          }

          .light::after {
            content: "";
            position: absolute;
            top: 0;
            right: -20px;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #D9D9D9;
            z-index: 1;
          }
        }
      }
    }
  }

  .my-tickets-section {
    margin: 12px 0;
    .my-tickets-tabs {
      display: flex;
      width: 100%;
      height: 32px;
      justify-content: space-between;
      border-radius: 8px;
      padding: 0;

      .button-tabs {
        width: max-content;
        height: 32px;
        padding: 3px 4px;
        border-radius: 8px;
        background-color: #D9D9D9;

        button {
          width: 66px;
          height: 24px;
          font-size: 14px;
          border-radius: 8px;
          color: #6E6E6E;
          background-color: #D9D9D9;
        }

        button.active {
          color: black;
          background-color: white;
        }
      }

      .nav-bar {
        display: flex;
        align-items: center;
        padding: 0;

        button {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          background: #D9D9D9;
        }

        .center-content {
          display: flex;
          width: 200px;
          height: 32px;
          margin: 0 12px;
          padding: 0 6px;
          align-items: center;
          border-radius: 6px;
          background: #D9D9D9;
        }

        .code-select {
          display: flex;
          width: 100%;
          margin-left: 8px;
          cursor: pointer;
          justify-content: space-between;
          font-size: 14px;
          font-weight: bold;
        }
      }

      .ticket-past-nav-bar {
      }
    }

    .my-tickets-info {
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      padding: 0;
      margin: 8px 0;

      .sub-tabs {
        border-bottom: 1px solid #333;
        button {
          width: 156px;
          height: 36px;
          font-size: 14px;
          color: black;
          background-color: white;
        }

        button.active {
          border-bottom: 4px #0C8CE9 solid;
          color: black;
          background-color: white;
        }
      }

      .ticket-active {
        display: flex;
        flex-wrap: wrap;
        overflow-y: auto;

        p {
          font-size: 14px;
          margin-bottom: 0;
        }

        .ticket-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 4px;

          >div {
            display: flex;
            align-items: center;

            .ticket-number {
              width: 120px;
              height: 40px;
              align-content: center;
              justify-items: center;
              background-image: url('/static/image/lotto/bg-ticket.png');

              p {
                font-size: 18px;
                font-weight: bold;
              }
            }

            .ticket-permutations {
              margin-left: 20px;
            }
          }

          .ticket-next-draw {

          }

          .ticket-card {
            display: flex;
            width: 100%;
            align-items: center;
            background: #ffffff;
            border: 1px solid #FFCE01;
            border-radius: 10px;
            padding: 14px 16px;
            gap: 14px;
          }

          .ticket-card--highlight {
            border-color: #f0c94a;
          }

          .ticket-main {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
            min-width: 0;
          }

          .ticket-badges {
            display: flex;
            gap: 6px;
          }

          .badge {
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: 600;
          }

          .badge--draw {
            background: #B1DEFF;
            color: #0C8CE9;
          }

          .badge--type {
            background: #D9D9D9;
            color: #6E6E6E;
          }

          .ticket-digits {
            display: flex;
            gap: 6px;
          }

          .digit-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 48px;
            border-radius: 6px;
            background: #FFF3C0;
            font-size: 20px;
            font-weight: 700;
            color: #1a1a1a;
          }

          .ticket-meta {
            margin: 0;
            font-size: 10px;
            color: #6e6e6e;
          }

          .ticket-divider {
            width: 1px;
            align-self: stretch;
            background: #FFCE01;
          }

          .ticket-chances {
            flex: 0 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 80px;
          }

          .chances-label {
            margin: 0;
            font-size: 10px;
            font-weight: 600;
            color: #6e6e6e;
          }

          .chances-value {
            margin: 2px 0;
            font-size: 20px;
            font-weight: 700;
            color: black;
          }

          .chances-sub {
            margin: 0;
            font-size: 10px;
            color: #6e6e6e;
          }
        }
      }

      .ticket-past {
        height: 600px;
        padding: 8px 16px;
        background-color: white;
        overflow-y: auto;

        p {
          font-size: 14px;
          margin-bottom: 0;
        }

        .ticket-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px dotted black;

          >div {
            display: flex;
            align-items: center;

            .text-your-ticket {
              width: 120px;
              height: 40px;
              align-content: center;
              justify-items: center;
              color: #6E6E6E;

              p {
                font-size: 12px;
                font-weight: bold;
              }
            }

            .ticket-number {
              width: 120px;
              height: 40px;
              align-content: center;
              justify-items: center;
              color: #6E6E6E;

              p {
                font-size: 18px;
                font-weight: bold;
              }
            }

            .ticket-number-blue {
              width: 120px;
              height: 40px;
              align-content: center;
              justify-items: center;

              p {
                font-size: 18px;
                font-weight: bold;
                color: #0c8ce9;
              }
            }

            .ticket-permutations {
              margin-left: 20px;

              p {
                font-size: 12px;
              }

              .text-blue {
                font-size: 14px;
                font-weight: bold;
                color: #0c8ce9;
              }
            }
          }

          .ticket-next-draw {
            .text-green {
              color: #17C977;
            }
          }
        }

        .nav-bar {
          display: flex;
          align-items: center;
          padding: 0;

          button {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .center-content {
            display: flex;
            width: 200px;
            height: 32px;
            margin: 0 12px;
            padding: 0 6px;
            align-items: center;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .code-select {
            display: flex;
            width: 100%;
            margin-left: 8px;
            cursor: pointer;
            justify-content: space-between;
            font-size: 14px;
            font-weight: bold;
          }
        }

        .ticket-past-nav-bar {
          justify-content: right;
        }
      }

      .ticket-no-result {
        height: 120px;
        align-content: center;
        background-color: #ebebeb;
        border: 1px dashed #959595;
        border-radius: 8px;

        .no-result {
          justify-items: center;

          p {
            font-size: 13.5px;
            color: #6E6E6E;
          }
        }
      }

      .ticket-past-no-result {
        height: 120px;
        align-content: center;
        background-color: #ebebeb;
        border: 1px dashed #959595;
        border-radius: 8px;

        .no-result {
          justify-items: center;

          p {
            font-size: 13.5px;
            color: #6E6E6E;
          }
        }
      }
    }

    .past-results-info {
      display: flex;
      flex-direction: column;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 0;
      margin: 8px 0;
      background-color: white;

      .past-result {
        height: 400px;
        padding: 8px 16px;
        background-color: white;

        p {
          font-size: 14px;
        }

        .nav-bar {
          display: flex;
          align-items: center;
          padding: 0;

          button {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .center-content {
            display: flex;
            width: 200px;
            height: 32px;
            margin: 0 12px;
            padding: 0 6px;
            align-items: center;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .code-select {
            display: flex;
            width: 100%;
            margin-left: 8px;
            cursor: pointer;
            justify-content: space-between;
            font-size: 14px;
            font-weight: bold;
          }
        }

        .prizes-list {
          width: 400px;
          margin: 20px;
          justify-self: center;
        }

        .game-info {
          display: flex;
          justify-content: space-between;

          p{
            font-size: 16px;
            font-weight: bolder;
            color: #6E6E6E;
          }
        }

        .prizes, .prizes-number {
          display: flex;
          font-weight: bold;
          margin: 6px 0;
          gap: 8px;

          .first-prize {
            font-size: 14px;
            background-color: #FFCE01;
          }

          .second-prize {
            font-size: 14px;
            background-color: #FFE36C;
          }

          .third-prize {
            font-size: 14px;
            background-color: #FFF1B4;
          }

          div {
            flex: 1;
            border-radius: 4px;
            height: 32px;
            align-content: center;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
          }
        }

        .other-prizes {
          margin-bottom: 16px;

          .prizes {
            border-radius: 4px;
            height: 32px;
            justify-content: center;
            align-items: center;
            margin: 8px 0;
            font-size: 12px;
            font-weight: bold;
            color: white;
            background-color: black;
          }

          .number-list {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            //gap: 10px;

            span {
              font-size: 16px;
              text-align: center;
              color: black;
            }
          }
        }
      }
    }
  }

  .last-draw-results {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .page-header {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .page-title {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .page-subtitle {
      margin: 0;
      font-size: 11px;
      color: #9a9ea6;
    }

    .match-banner {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #FFF3C0;
      border-radius: 10px;
      padding: 6px 16px;
      border: 1px solid #FFCE01;
    }

    .match-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 50%;
      background: #FFCE01;
    }

    .match-title {
      margin: 0;
      font-size: 11px;
      font-weight: 700;
      color: black;
    }

    .match-breakdown {
      margin: 0;
      font-size: 11px;
      color: #6E6E6E;
    }

    .top-prizes-card {
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
    }

    .top-prize-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
      border-bottom: 1px solid #eceef1;
    }

    .top-prize-row:last-child {
      border-bottom: none;
    }

    .top-prize-label {
      display: flex;
      margin: 0;
      align-items: center;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .first-prize-label {
      color: #B7860C;
    }

    .second-prize-label {
      color: #6B7280;
    }

    .third-prize-label {
      color: #8B4A22;
    }

    .digit-boxes {
      display: flex;
      gap: 6px;
    }

    .digit-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 48px;
      border-radius: 6px;
      background: #F0EBDD;
      font-size: 20px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .prize-section {
      background: #ffffff;
      border-radius: 10px;
      padding: 16px 20px;
    }

    .section-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
    }

    .section-title {
      width: 72px;
      margin: 0;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .count-badge {
      padding: 2px 8px;
      border-radius: 999px;
      background: #eceef1;
      font-size: 11px;
      font-weight: 600;
      color: #6a6f78;
    }

    .numbers-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
    }

    .number-card {
      display: flex;
      position: relative;
      height: 56px;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 10px 14px;
      border-radius: 8px;
      background: #F0EBDD;
      border: 1.5px solid transparent;
    }

    .number-value {
      font-size: 15px;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 2px;
      text-align: center;
    }
    .number-index {
      position: absolute;
      left: 14px;
      font-size: 11px;
      color: #9a9280;
    }

    .number-value {
      font-size: 16px;
      font-weight: 700;
      color: #000000;
      letter-spacing: 2px;
    }

    .top-matched-star {
      display: flex;
      margin-left: 6px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-star {
      display: flex;
      position: absolute;
      top: -8px;
      right: -8px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-number {
      border: 1px solid #FFCE01 !important;
      background-color: #FFF3C0 !important;
    }
  }

  .past-results-card {
    background: #ffffff;
    border-radius: 10px;
    padding: 8px 12px;
    margin-top: 12px;

    .nav-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;

      button {
        width: 28px;
        height: 28px;
        border-radius: 6px;
        background: #D9D9D9;
      }

      .center-content {
        display: flex;
        width: 132px;
        height: 28px;
        margin: 0 4px;
        padding: 0 6px;
        align-items: center;
        border-radius: 6px;
        background: #D9D9D9;
      }

      .code-select {
        display: flex;
        width: 100%;
        cursor: pointer;
        margin-left: 2px;
        justify-content: space-between;
        font-size: 12px;
        font-weight: bold;
      }
    }

    .ticket-past-nav-bar {
      justify-content: right;
    }

    .past-result-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .past-result-title {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .draw-row-wrapper {
      border-top: 1px solid #eceef1;
    }

    .draw-row-wrapper:first-of-type {
      border-top: none;
    }

    .draw-summary-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding: 14px 0;
    }

    .draw-date-info {
      flex: 0 0 auto;
      min-width: 90px;
    }

    .draw-date {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .draw-id {
      margin: 0;
      font-size: 11px;
      color: #9a9ea6;
    }

    .draw-top-prizes {
      display: flex;
      gap: 16px;
      margin-bottom: 12px;
      justify-content: space-between;
    }

    .mini-prize {
      display: flex;
      position: relative;
      flex-direction: column;
      width: 100px;
    }

    .mini-prize-label {
      margin: 0;
      font-size: 12px;
      font-weight: 700;
    }

    .first-prize-label {
      color: #B7860C;
    }

    .second-prize-label {
      color: #6B7280;
    }

    .third-prize-label {
      color: #8B4A22;
    }

    .mini-digit-box {
      display: flex;
      width: 100%;
      height: 32px;
      align-items: center;
      justify-content: center;
      padding: 6px 8px;
      border-radius: 8px;
      background: #F0EBDD;
      font-size: 16px;
      font-weight: bold;
      color: #6E6E6E;
      letter-spacing: 2px;
    }

    .draw-match-info {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 0 0 auto;
    }

    .match-badge {
      padding: 4px 12px;
      border-radius: 999px;
      background: #fdeaa0;
      color: #7a5c00;
      font-size: 12px;
      font-weight: 700;
      white-space: nowrap;
    }

    .match-badge--none {
      background: #eceef1;
      color: #8a8f98;
    }

    .chevron-expanded {
      transform: rotate(90deg);
      transition: transform 0.15s ease;
    }

    .draw-expanded {
      padding-bottom: 16px;
      display: flex;
      flex-direction: column;
    }

    .match-banner {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #FFF3C0;
      border-radius: 10px;
      padding: 6px 16px;
      border: 1px solid #FFCE01;
    }

    .match-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 50%;
      background: #FFCE01;
    }

    .match-title {
      margin: 0;
      font-size: 11px;
      font-weight: 700;
      color: black;
    }

    .match-breakdown {
      margin: 0;
      font-size: 11px;
      color: #6E6E6E;
    }

    .prize-section {
      background: #F0EBDD;
      padding: 8px 12px;
    }

    .prize-border {
      padding: 12px 12px;
      border-radius: 8px;
      background-color: white;
      border: 1px solid #FFCE01;
    }

    .section-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
    }

    .section-title {
      min-width: 72px;
      margin: 0;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .count-badge {
      padding: 2px 8px;
      border-radius: 999px;
      background: #eceef1;
      font-size: 11px;
      font-weight: 600;
      color: #6a6f78;
    }

    .numbers-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
    }

    .number-card {
      display: flex;
      position: relative;
      height: 46px;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 10px 14px;
      border-radius: 8px;
      background: #f0ebdd;
      border: 1.5px solid transparent;
    }

    .number-card--matched {
      background: #fdeaa0;
      border-color: #f0b90b;
    }

    .number-index {
      position: absolute;
      left: 14px;
      font-size: 11px;
      color: #9a9280;
    }

    .number-value {
      font-size: 16px;
      font-weight: 700;
      color: black;
      letter-spacing: 2px;
      text-align: center;
    }

    .top-matched-star {
      display: flex;
      position: absolute;
      top: 12px;
      right: -8px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-star {
      display: flex;
      position: absolute;
      top: -8px;
      right: -8px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-number {
      border: 1px solid #FFCE01 !important;
      background-color: #FFF3C0 !important;
    }
  }

  .lotto-ui {
    font-family: Arial, sans-serif;
    padding: 20px;
  }

  .tabs button,
  .sub-tabs button {
    margin-right: 10px;
    padding: 8px 16px;
    border: none;
    background: #eee;
    cursor: pointer;
  }

  .tabs button.active,
  .sub-tabs button.active {
    background: #007bff;
    color: #fff;
  }

  .ticket-info {
    margin-top: 20px;
  }

  .no-tickets {
    margin-top: 10px;
    color: #555;
  }

  .btn-earn-ticket {
    margin-top: 10px;
    padding: 8px 16px;
    background: #28a745;
    color: #fff;
    border: none;
    cursor: pointer;
  }

  .btn-earn-ticket:disabled {
    background: #ccc;
    color: #666;
    cursor: not-allowed;
  }

  .faq-section {
    gap: 12px;
    margin: 12px 0;

    .text-rules {
      font-size: 16px;
      font-weight: bolder;
    }

    .accordion {
      border: 1px solid #ddd;
      border-radius: 8px;
      overflow: hidden;
    }

    .accordion-item {
      border-bottom: 1px solid #ddd;
    }

    .accordion-header {
      background: white;
      padding: 12px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      font-weight: bold;

      span {
        font-size: 12px;
      }
    }

    .accordion-header:hover {
      background: #eaeaea;
    }

    .accordion-body {
      padding: 2px 12px;
      background: #fff;
      color: #333;
      white-space: pre-line;

      p {
        font-size: 12px;
      }
    }

    .arrow {
      transition: transform 0.3s;
    }

    .arrow.open {
      transform: rotate(180deg);
    }
  }
}

.margin-lotto-mobile {
  margin: 16px 8px;
  padding: 0px !important;

  .lotto-marquee-row {
    padding: 0 7px !important;
  }

  .lotto-marquee-wrapper {
    display: flex;
    align-items: center;
    max-width: 100%;
    min-width: 100%;
    margin: auto;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background-color: #333333;
  }

  .lotto-marquee {
    height: 30px;
    border: none;
    border-radius: 0px !important;
    background-color: transparent !important;

    span {
      label {
        color: white !important;
        font-size: 13px;
        line-height: 30px;
      }
    }
  }

  .lotto-marquee-content {
    display: inline-block;
    white-space: nowrap;
    animation: scroll-left-mobile 160s linear infinite;
  }

  @keyframes scroll-left-mobile {
    from { transform: translateX(10vw); }
    to   { transform: translateX(-100%); }
  }

  .lottery-wrapper {
    font-family: inherit;

    .lottery-title {
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 10px;
      letter-spacing: 0.3px;
    }

    .lottery-card {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #eceef1;
      padding: 8px 10px;
      margin-bottom: 12px;
    }

    .top-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .subtitle {
      margin: 0;
      font-size: 11px;
      color: #8a8f98;
    }

    .ticket-graphic {
      display: block;
      width: 160px;
      height: auto;
    }

    .hint-text {
      margin: 2px 0 0;
      font-weight: bold;
      font-size: 11px;
      color: #000000;
    }

    .prize-boxes {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      margin: 4px 0;
    }

    .prize-box {
      flex: 1;
      min-width: 104px;
      background: #FFF3C0;
      border-radius: 6px;
      padding: 8px 10px;
    }

    .prize-box-label {
      margin: 0 0 4px;
      font-size: 8px;
      color: #6E6E6E;
      line-height: 1.3;
    }

    .prize-box-value {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #000000;
    }

    .horizontal-divider {
      height: 2px;
      min-width: 100%;
      background: #eceef1;
      margin: 8px 0;
    }

    .down-panel {
      flex: 1;
      display: flex;
      min-width: 200px;
      justify-content: space-between;
    }

    .ticket-id {
      align-self: flex-end;
      font-size: 11px;
      color: #8a8f98;
    }

    .draw-closes-label {
      margin: 0 0 4px;
      font-size: 10px;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 0.3px;
    }

    .countdown-boxes {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .countdown-box {
      width: 32px;
      height: 32px;
      text-align: center;
      align-content: center;
      border-radius: 4px;
      background: #f4f4f4;
      color: #0C8CE9;
      font-size: 18px;
      font-weight: 500;
      font-variant-numeric: tabular-nums;
    }

    .countdown-colon {
      color: #000000;
      font-size: 18px;
      font-weight: 500;
    }

    .active-tickets {
    }

    .active-tickets-label {
      margin: 0;
      font-size: 10px;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 0.3px;
    }

    .active-tickets-value {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #FFCE01;
    }

    .winners-ticker {
      margin-top: 10px;
      background: #1a1a1a;
      border-radius: 8px;
      overflow: hidden;
      padding: 8px 0;
    }

    .ticker-track {
      display: flex;
      gap: 32px;
      white-space: nowrap;
      animation: ticker-scroll 22s linear infinite;
    }

    .ticker-item {
      font-size: 12px;
      color: #d8d8d8;
    }

    @keyframes ticker-scroll {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }
  }

  .lottery-banner-section {
    display: flex;
    flex-direction: column;
    padding: 4px 8px;
    border-radius: 8px;
    background-color: white;

    .prizes-list {
      width: 100%;
    }

    .game-info {
      display: flex;
      justify-content: space-between;

      p{
        font-size: 16px;
        font-weight: bolder;
        color: #6E6E6E;
      }
    }

    .prizes, .prizes-number {
      display: flex;
      font-weight: bold;
      margin: 6px 0;
      gap: 8px;

      .first-prize {
        font-size: 14px;
        background-color: #FFCE01;
      }

      .second-prize {
        font-size: 14px;
        background-color: #FFE36C;
      }

      .third-prize {
        font-size: 14px;
        background-color: #FFF1B4;
      }

      div {
        flex: 1;
        border-radius: 4px;
        height: 32px;
        align-content: center;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }
    }

    .other-prizes {
      margin-bottom: 16px;

      .prizes {
        border-radius: 4px;
        height: 32px;
        justify-content: center;
        align-items: center;
        margin: 8px 0;
        font-size: 12px;
        font-weight: bold;
        color: white;
        background-color: black;
      }

      .number-list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        //gap: 10px;

        span {
          font-size: 16px;
          text-align: center;
          color: black;
        }
      }
    }

    .countdown {
      text-align: center;
      align-content: center;
      color: black;

      .next-draw {
        font-size: 12px;
        margin: 0;
      }

      .countdown-time {
        font-size: 28px;
        font-weight: bolder;
        margin-bottom: 8px;
      }

      .btn-earn-ticket {
        width: 144px;
        height: 40px;
        background: #FFCE01;
        border-radius: 6px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: black;
        padding: 8px;
        white-space: nowrap;
      }

      .btn-earn-ticket:disabled {
        background-color: #ccc;
        color: #666;
        cursor: default;
        opacity: 0.7;
      }
    }
  }

  .winning-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0 0 12px;

    .winning-box {
      flex: 1;
      display: flex;
      min-height: 64px;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 6px 10px;
      background: #fff;

      p {
        font-size: 12px;
        color: black;
        margin-bottom: 4px;
      }

      .winnings-amount {
        font-size: 18px;
      }

      .btn-claim {
        width: 96px;
        height: 36px;
        background: #FFCE01;
        border-radius: 6px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: black;
      }

      .btn-claim:disabled {
        background-color: #ccc;
        color: #666;
        cursor: default;
        opacity: 0.7;
      }

      .active-tickets {
        display: flex;

        p {
          font-size: 18px;
        }

        .active {
          color: #FFCE01;
        }
      }
    }

    .winning-row {
      display: flex;
      gap: 4px;
    }
  }


  .tickets-section {
    gap: 4px;
    margin: 8px 0 0;
    .text-tickets {
      font-size: 14px;
      font-weight: bolder;
      margin-bottom: 0;
    }

    .tickets-list {
      display: flex;
      gap: 4px;
      margin: 4px 0;
      .tickets-box {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 94px;
        justify-content: space-between;
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 6px 10px;
        background: #fff;

        .tickets-header-row {
          display: flex;
          justify-content: space-between;
        }

        .ticket-text {
          p {
            font-size: 12px;
            color: black;
            margin-bottom: 0px;
          }

          .subtitle {
            font-size: 10px;
            color: #6e6e6e;
          }

          .ticket-number {
            font-size: 18px;
            color: #FFCE01;
          }

          .text-refer {
            font-size: 12px;
            font-weight: bold;
          }

          .text-refer-desc {
            font-size: 10px;
          }
        }

        .bonus-badge {
          flex-shrink: 0;
          height: 40px;
          text-align: center;
          align-content: center;
          align-self: center;
          border-radius: 8px;
          background: #FFF3C0;
          color: #FFCE01;
          padding: 0 4px;
          font-size: 22px;
          font-weight: 700;
        }

        .refer-box {
          display: flex;
          width: 50%;
          justify-content: end;
          gap: 8px;

          .border-referral {
            width: 144px;
            height: 40px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            align-items: center;
            background-color: #D9D9D9;

            .v-input__slot {
              padding: 8px;

              .v-input__append-inner {
                width: 36px;
              }
            }
          }

          .btn-refer-now {
            width: 120px;
            height: 40px;
            background: #FFCE01;
            border-radius: 6px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            color: black;
          }
        }

        .img-ticket {
          width: 92px;
        }

        .progress-track {
          position: relative;
          width: 100%;
          min-height: 8px;
          border-radius: 999px;
          background: #D9D9D9;
          overflow: hidden;
          margin: 4px 0 4px;
        }

        .progress-fill {
          min-height: 8px;
          border-radius: 999px;
          background: #FFCE01;
          transition: width 0.3s ease;
        }

        .progress-label {
          margin: 0;
          font-size: 12px;
          color: #000000;
        }
      }

      .daily-box {
        flex: 1;
        height: 120px;
        align-content: center;
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 0 16px;
        background: #fff;

        >div {
          display: flex;
          justify-content: space-between;
        }
        .daily-text {
          .text-daily {
            font-size: 12px;
            font-weight: bold;
            margin-bottom: 0;
          }

          .text-daily-desc {
            font-size: 12px;
            margin-bottom: 0;
          }
        }

        .daily-amount {
          font-size: 20px;
          font-weight: bold;
        }

        .daily-progress-bar {
          display: flex;
          width: 100%;
          gap: 28px;

          .step {
            flex: 1;
            height: 40px;
            position: relative;
            padding: 12px;
            text-align: center;
            color: #000;
            font-weight: bold;
          }

          .step:last-child::after {
            display: none;
          }

          .completed {
            background: #FFCE01;
            color: #000;
          }

          .completed::after {
            content: "";
            position: absolute;
            top: 0;
            right: -20px;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #FFCE01;
            z-index: 1;
          }

          .dark {
            background: black;
            color: #fff;
          }

          .dark::after {
            content: "";
            position: absolute;
            top: 0;
            right: -20px;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid black;
            z-index: 1;
          }

          .light {
            background: #D9D9D9;
            color: #6E6E6E;
          }

          .light::after {
            content: "";
            position: absolute;
            top: 0;
            right: -20px;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid #D9D9D9;
            z-index: 1;
          }
        }
      }
    }
  }

  .my-tickets-section {
    margin: 12px 0;

    .text-tickets {
      font-size: 16px;
      font-weight: bolder;
      margin-bottom: 0;
    }

    .my-tickets-tabs {
      display: flex;
      width: 100%;
      height: 32px;
      justify-content: space-between;
      border-radius: 8px;
      padding: 0;

      .button-tabs {
        width: max-content;
        height: 32px;
        padding: 3px 4px;
        border-radius: 8px;
        background-color: #D9D9D9;

        button {
          width: 56px;
          height: 24px;
          font-size: 12px;
          border-radius: 8px;
          color: #6E6E6E;
          background-color: #D9D9D9;
        }

        button.active {
          color: black;
          background-color: white;
        }
      }

      .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;

        button {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          background: #D9D9D9;
        }

        .center-content {
          display: flex;
          width: 144px;
          height: 32px;
          margin: 0 4px;
          padding: 0 6px;
          align-items: center;
          border-radius: 6px;
          background: #D9D9D9;
        }

        .code-select {
          display: flex;
          width: 100%;
          cursor: pointer;
          margin-left: 2px;
          justify-content: space-between;
          font-size: 13px;
          font-weight: bold;
        }
      }

      .ticket-past-nav-bar {
        width: 216px;
      }
    }

    .my-tickets-info {
      display: flex;
      flex-direction: column;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 0;
      margin: 8px 0;
      background-color: white;

      .sub-tabs {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #333;
        button {
          width: 50%;
          height: 40px;
          font-size: 14px;
          color: black;
          background-color: white;
        }

        button.active {
          border-bottom: 4px #0C8CE9 solid;
          color: black;
          background-color: white;
        }
      }

      .ticket-active {
        height: 400px;
        padding: 8px 6px;
        background-color: white;
        overflow-y: auto;

        p {
          font-size: 12px;
          margin-bottom: 0;
        }

        .ticket-list {
          display: flex;
          min-height: 60px;
          padding: 8px 0;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px dotted black;

          >div {
            display: flex;
            align-items: center;

            .ticket-number {
              width: 80px;
              height: 44px;
              align-content: center;
              justify-items: center;
              background-image: url('/static/image/lotto/bg-ticket.png');

              p {
                font-size: 16px;
                font-weight: bold;
                float: right;
                padding-right: 14px;
              }
            }

            .ticket-permutations {
              margin-left: 6px;
            }
          }

          .ticket-next-draw {

          }

          .ticket-card {
            display: flex;
            width: 100%;
            align-items: center;
            background: #ffffff;
            border: 1px solid #FFCE01;
            border-radius: 10px;
            padding: 14px 16px;
            gap: 14px;
          }

          .ticket-card--highlight {
            border-color: #f0c94a;
          }

          .ticket-main {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
            min-width: 0;
          }

          .ticket-badges {
            display: flex;
            gap: 6px;
          }

          .badge {
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: 600;
          }

          .badge--draw {
            background: #B1DEFF;
            color: #0C8CE9;
          }

          .badge--type {
            background: #D9D9D9;
            color: #6E6E6E;
          }

          .ticket-digits {
            display: flex;
            gap: 6px;
          }

          .digit-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 48px;
            border-radius: 6px;
            background: #FFF3C0;
            font-size: 20px;
            font-weight: 700;
            color: #1a1a1a;
          }

          .ticket-meta {
            margin: 0;
            font-size: 10px;
            color: #6e6e6e;
          }

          .ticket-divider {
            width: 1px;
            align-self: stretch;
            background: #FFCE01;
          }

          .ticket-chances {
            flex: 0 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 80px;
          }

          .chances-label {
            margin: 0;
            font-size: 10px;
            font-weight: 600;
            color: #6e6e6e;
          }

          .chances-value {
            margin: 2px 0;
            font-size: 20px;
            font-weight: 700;
            color: black;
          }

          .chances-sub {
            margin: 0;
            font-size: 10px;
            color: #6e6e6e;
          }
        }
      }

      .ticket-past {
        height: 400px;
        padding: 8px 6px;
        background-color: white;
        overflow-y: auto;

        p {
          font-size: 12px;
          margin-bottom: 0;
        }

        .ticket-list {
          display: flex;
          min-height: 60px;
          padding: 8px 0;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px dotted black;

          >div {
            display: flex;
            align-items: center;

            .text-your-ticket {
              width: 72px;
              height: 40px;
              align-content: center;
              justify-items: center;
              color: #6E6E6E;

              p {
                font-size: 12px;
                font-weight: bold;
              }
            }

            .ticket-number {
              width: 120px;
              height: 40px;
              align-content: center;
              justify-items: center;
              color: #6E6E6E;

              p {
                font-size: 18px;
                font-weight: bold;
              }
            }

            .ticket-number-blue {
              width: 72px;
              height: 40px;
              align-content: center;
              justify-items: center;

              p {
                font-size: 18px;
                font-weight: bold;
                color: #0c8ce9;
              }
            }

            .ticket-permutations {
              margin-left: 20px;

              p {
                font-size: 12px;
              }

              .text-blue {
                font-size: 14px;
                font-weight: bold;
                color: #0c8ce9;
              }
            }
          }

          .ticket-next-draw {
            .text-green {
              color: #17C977;
            }
          }
        }

        .nav-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0;

          button {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .center-content {
            display: flex;
            width: 200px;
            height: 32px;
            margin: 0 12px;
            padding: 0 6px;
            align-items: center;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .code-select {
            display: flex;
            width: 100%;
            margin-left: 8px;
            cursor: pointer;
            justify-content: space-between;
            font-size: 14px;
            font-weight: bold;
          }
        }

        .ticket-past-nav-bar {
        }
      }

      .ticket-no-result {
        height: 120px;
        align-content: center;
        background-color: #ebebeb;
        border: 1px dashed #959595;
        border-radius: 8px;

        .no-result {
          justify-items: center;

          p {
            font-size: 13.5px;
            color: #6E6E6E;
          }
        }
      }
    }

    .past-results-info {
      display: flex;
      flex-direction: column;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 0;
      margin: 8px 0;
      background-color: white;

      .past-result {
        height: 400px;
        padding: 8px 16px;
        background-color: white;

        p {
          font-size: 14px;
        }

        .nav-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0;

          button {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .center-content {
            display: flex;
            width: 200px;
            height: 32px;
            margin: 0 12px;
            padding: 0 6px;
            align-items: center;
            border-radius: 6px;
            background: #D9D9D9;
          }

          .code-select {
            display: flex;
            width: 100%;
            margin-left: 8px;
            cursor: pointer;
            justify-content: space-between;
            font-size: 14px;
            font-weight: bold;
          }
        }

        .prizes-list {
          width: 100%;
          margin: 20px;
          justify-self: center;
        }

        .game-info {
          display: flex;
          justify-content: space-between;

          p{
            font-size: 16px;
            font-weight: bolder;
            color: #6E6E6E;
          }
        }

        .prizes, .prizes-number {
          display: flex;
          font-weight: bold;
          margin: 6px 0;
          gap: 8px;

          .first-prize {
            font-size: 14px;
            background-color: #FFCE01;
          }

          .second-prize {
            font-size: 14px;
            background-color: #FFE36C;
          }

          .third-prize {
            font-size: 14px;
            background-color: #FFF1B4;
          }

          div {
            flex: 1;
            border-radius: 4px;
            height: 32px;
            align-content: center;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
          }
        }

        .other-prizes {
          margin-bottom: 16px;

          .prizes {
            border-radius: 4px;
            height: 32px;
            justify-content: center;
            align-items: center;
            margin: 8px 0;
            font-size: 12px;
            font-weight: bold;
            color: white;
            background-color: black;
          }

          .number-list {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            //gap: 10px;

            span {
              font-size: 16px;
              text-align: center;
              color: black;
            }
          }
        }
      }
    }
  }

  .last-draw-results {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .page-header {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .page-title {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .page-subtitle {
      margin: 0;
      font-size: 11px;
      color: #9a9ea6;
    }

    .match-banner {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #FFF3C0;
      border-radius: 10px;
      padding: 6px 16px;
      border: 1px solid #FFCE01;
    }

    .match-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 50%;
      background: #FFCE01;
    }

    .match-title {
      margin: 0;
      font-size: 11px;
      font-weight: 700;
      color: black;
    }

    .match-breakdown {
      margin: 0;
      font-size: 11px;
      color: #6E6E6E;
    }

    .top-prizes-card {
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
      padding: 4px 12px;
    }

    .top-prize-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0px;
      border-bottom: 1px solid #eceef1;
    }

    .top-prize-row:last-child {
      border-bottom: none;
    }

    .top-prize-label {
      display: flex;
      margin: 0;
      align-items: center;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .digit-boxes {
      display: flex;
      gap: 6px;
    }

    .digit-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 40px;
      border-radius: 6px;
      background: #F0EBDD;
      font-size: 18px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .prize-section {
      background: #ffffff;
      border-radius: 10px;
      padding: 8px 12px;
    }

    .section-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
    }

    .section-title {
      min-width: 72px;
      margin: 0;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .count-badge {
      padding: 2px 8px;
      border-radius: 999px;
      background: #eceef1;
      font-size: 11px;
      font-weight: 600;
      color: #6a6f78;
    }

    .numbers-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }

    .number-card {
      display: flex;
      position: relative;
      height: 56px;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 10px 14px;
      border-radius: 8px;
      background: #F0EBDD;
      border: 1.5px solid transparent;
    }

    .number-value {
      font-size: 15px;
      font-weight: 700;
      color: #1a1a1a;
      letter-spacing: 2px;
      text-align: center;
    }
    .number-index {
      position: absolute;
      left: 14px;
      font-size: 11px;
      color: #9a9280;
    }

    .number-value {
      font-size: 16px;
      font-weight: 700;
      color: #000000;
      letter-spacing: 2px;
    }

    .top-matched-star {
      display: flex;
      margin-left: 6px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-star {
      display: flex;
      position: absolute;
      top: -8px;
      right: -8px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-number {
      border: 1px solid #FFCE01 !important;
      background-color: #FFF3C0 !important;
    }
  }

  .past-results-card {
    background: #ffffff;
    border-radius: 10px;
    padding: 8px 12px;
    margin-top: 12px;

    .nav-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;

      button {
        width: 28px;
        height: 28px;
        border-radius: 6px;
        background: #D9D9D9;
      }

      .center-content {
        display: flex;
        width: 132px;
        height: 28px;
        margin: 0 4px;
        padding: 0 6px;
        align-items: center;
        border-radius: 6px;
        background: #D9D9D9;
      }

      .code-select {
        display: flex;
        width: 100%;
        cursor: pointer;
        margin-left: 2px;
        justify-content: space-between;
        font-size: 12px;
        font-weight: bold;
      }
    }

    .ticket-past-nav-bar {
      justify-content: right;
    }

    .past-result-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .past-result-title {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .draw-row-wrapper {
      border-top: 1px solid #eceef1;
    }

    .draw-row-wrapper:first-of-type {
      border-top: none;
    }

    .draw-summary-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding: 14px 0;
    }

    .draw-date-info {
      flex: 0 0 auto;
      min-width: 90px;
    }

    .draw-date {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .draw-id {
      margin: 0;
      font-size: 11px;
      color: #9a9ea6;
    }

    .draw-top-prizes {
      display: flex;
      gap: 16px;
      margin-bottom: 12px;
      justify-content: space-between;
    }

    .mini-prize {
      display: flex;
      position: relative;
      flex-direction: column;
      width: 100%;
    }

    .mini-prize-label {
      margin: 0;
      font-size: 12px;
      font-weight: 700;
    }

    .first-prize-label {
      color: #B7860C;
    }

    .second-prize-label {
      color: #6B7280;
    }

    .third-prize-label {
      color: #8B4A22;
    }

    .mini-digit-box {
      display: flex;
      width: 100%;
      height: 32px;
      align-items: center;
      justify-content: center;
      padding: 6px 8px;
      border-radius: 8px;
      background: #F0EBDD;
      font-size: 16px;
      font-weight: bold;
      color: #6E6E6E;
      letter-spacing: 2px;
    }

    .draw-match-info {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 0 0 auto;
    }

    .match-badge {
      padding: 4px 12px;
      border-radius: 999px;
      background: #fdeaa0;
      color: #7a5c00;
      font-size: 12px;
      font-weight: 700;
      white-space: nowrap;
    }

    .match-badge--none {
      background: #eceef1;
      color: #8a8f98;
    }

    .chevron-expanded {
      transform: rotate(90deg);
      transition: transform 0.15s ease;
    }

    .draw-expanded {
      padding-bottom: 16px;
      display: flex;
      flex-direction: column;
    }

    .match-banner {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #FFF3C0;
      border-radius: 10px;
      padding: 6px 16px;
      border: 1px solid #FFCE01;
    }

    .match-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 50%;
      background: #FFCE01;
    }

    .match-title {
      margin: 0;
      font-size: 11px;
      font-weight: 700;
      color: black;
    }

    .match-breakdown {
      margin: 0;
      font-size: 11px;
      color: #6E6E6E;
    }

    .prize-section {
      background: #F0EBDD;
      padding: 8px 12px;
    }

    .prize-border {
      padding: 12px 12px;
      border-radius: 8px;
      background-color: white;
      border: 1px solid #FFCE01;
    }

    .section-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
    }

    .section-title {
      min-width: 72px;
      margin: 0;
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .count-badge {
      padding: 2px 8px;
      border-radius: 999px;
      background: #eceef1;
      font-size: 11px;
      font-weight: 600;
      color: #6a6f78;
    }

    .numbers-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }

    .number-card {
      display: flex;
      position: relative;
      height: 46px;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 10px 14px;
      border-radius: 8px;
      background: #f0ebdd;
      border: 1.5px solid transparent;
    }

    .number-card--matched {
      background: #fdeaa0;
      border-color: #f0b90b;
    }

    .number-index {
      position: absolute;
      left: 14px;
      font-size: 11px;
      color: #9a9280;
    }

    .number-value {
      font-size: 16px;
      font-weight: 700;
      color: black;
      letter-spacing: 2px;
      text-align: center;
    }

    .top-matched-star {
      display: flex;
      position: absolute;
      top: 12px;
      right: -8px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-star {
      display: flex;
      position: absolute;
      top: -8px;
      right: -8px;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #FFCE01;
      color: black;
      font-size: 16px;
      font-weight: normal;
    }

    .matched-number {
      border: 1px solid #FFCE01 !important;
      background-color: #FFF3C0 !important;
    }
  }

  .lotto-ui {
    font-family: Arial, sans-serif;
    padding: 20px;
  }

  .tabs button,
  .sub-tabs button {
    margin-right: 10px;
    padding: 8px 16px;
    border: none;
    background: #eee;
    cursor: pointer;
  }

  .tabs button.active,
  .sub-tabs button.active {
    background: #007bff;
    color: #fff;
  }

  .ticket-info {
    margin-top: 20px;
  }

  .no-tickets {
    margin-top: 10px;
    color: #555;
  }

  .btn-earn-ticket {
    margin-top: 10px;
    padding: 8px 16px;
    background: #28a745;
    color: #fff;
    border: none;
    cursor: pointer;
  }

  .btn-earn-ticket:disabled {
    background: #ccc;
    color: #666;
    cursor: not-allowed;
  }

  .faq-section {
    gap: 12px;
    margin: 12px 0;

    .text-rules {
      font-size: 16px;
      font-weight: bolder;
    }

    .accordion {
      border: 1px solid #ddd;
      border-radius: 8px;
      overflow: hidden;
    }

    .accordion-item {
      border-bottom: 1px solid #ddd;
    }

    .accordion-header {
      background: white;
      padding: 12px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      font-weight: bold;

      span {
        font-size: 12px;
      }
    }

    .accordion-header:hover {
      background: #eaeaea;
    }

    .accordion-body {
      padding: 2px 12px;
      background: #fff;
      color: #333;
      white-space: pre-line;

      p {
        font-size: 12px;
      }
    }

    .arrow {
      transition: transform 0.3s;
    }

    .arrow.open {
      transform: rotate(180deg);
    }
  }
}
</style>
